(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giesto-arket-promotions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.GiestoCategoryPromosMore) return;
    window.GiestoCategoryPromosMore = true;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-ga-category-promos-more]');
      if (!(button instanceof HTMLButtonElement)) return;

      const promos = button.closest('[data-ga-category-promos]');
      if (!(promos instanceof HTMLElement)) return;

      const expanded = promos.dataset.expanded !== 'true';
      promos.dataset.expanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));

      const label = button.querySelector('[data-ga-category-promos-more-label]');
      const text = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (label && text) label.textContent = text;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-editorial-pairs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-editorial-pairs')) {
    class GiestoEditorialPairs extends HTMLElement {
      connectedCallback() {
        this.teardown();

        this.parallaxItems = Array.from(
          this.querySelectorAll('[data-giesto-editorial-parallax="true"]')
        );
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        this.parallaxStates = [];
        this.onScroll = this.handleScroll.bind(this);
        this.onMotionChange = this.handleMotionChange.bind(this);
        this.onImageLoad = this.handleImageLoad.bind(this);
        this.onSectionLoad = this.handleSectionLoad.bind(this);
        this.onSectionUnload = this.handleSectionUnload.bind(this);

        this.addMediaListener(this.motionQuery, this.onMotionChange);
        document.addEventListener('shopify:section:load', this.onSectionLoad, { signal: this.controller.signal });
        document.addEventListener('shopify:section:unload', this.onSectionUnload, { signal: this.controller.signal });

        this.setupParallax();
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        if (this.animationFrame) {
          window.cancelAnimationFrame(this.animationFrame);
        }

        this.animationFrame = null;

        if (this.motionQuery && this.onMotionChange) {
          this.removeMediaListener(this.motionQuery, this.onMotionChange);
        }

        if (this.controller) {
          this.controller.abort();
        }

        this.parallaxStates?.forEach((state) => {
          state.overlay.style.removeProperty('--giesto-editorial-parallax-y');
          state.overlay.classList.remove('is-visible');
          delete state.overlay.dataset.giestoParallaxManaged;
        });

        this.parallaxItems = [];
        this.parallaxStates = [];
        this.controller = null;
      }

      addMediaListener(query, listener) {
        if (query.addEventListener) {
          query.addEventListener('change', listener);
        } else {
          query.addListener(listener);
        }
      }

      removeMediaListener(query, listener) {
        if (query.removeEventListener) {
          query.removeEventListener('change', listener);
        } else {
          query.removeListener(listener);
        }
      }

      handleScroll() {
        this.refreshParallax(this.motionQuery?.matches);
      }

      handleMotionChange(event) {
        this.refreshParallax(event.matches);
      }

      handleImageLoad() {
        this.refreshParallax(this.motionQuery?.matches);
      }

      handleSectionLoad(event) {
        if (this.ownsSectionEvent(event) && this.isConnected) {
          this.connectedCallback();
        }
      }

      handleSectionUnload(event) {
        if (this.ownsSectionEvent(event)) {
          this.teardown();
        }
      }

      ownsSectionEvent(event) {
        const target = event.target;
        return target === this || Boolean(target?.contains?.(this));
      }

      setupParallax() {
        if (!this.parallaxItems.length) return;

        this.parallaxStates = this.parallaxItems
          .map((overlay) => ({
            overlay,
            section: overlay.closest('.giesto-editorial-pairs__media--right'),
            currentY: 0,
            targetY: 0,
          }))
          .filter((state) => state.section);

        if (!this.parallaxStates.length) return;

        this.parallaxStates.forEach((state) => {
          state.overlay.dataset.giestoParallaxManaged = 'true';
          state.overlay.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', this.onImageLoad, { signal: this.controller.signal });
            if (image.complete) this.handleImageLoad();
          });
        });

        this.querySelectorAll('.giesto-editorial-pairs__image').forEach((image) => {
          image.addEventListener('load', this.onImageLoad, { signal: this.controller.signal });
          if (image.complete) this.handleImageLoad();
        });

        document.addEventListener('scroll', this.onScroll, {
          capture: true,
          passive: true,
          signal: this.controller.signal,
        });
        window.addEventListener('resize', this.onScroll, {
          passive: true,
          signal: this.controller.signal,
        });

        this.refreshParallax(this.motionQuery.matches);
      }

      refreshParallax(immediate = false) {
        if (!this.parallaxStates?.length) return;

        const shouldApplyImmediately = Boolean(immediate || this.motionQuery?.matches);

        if (shouldApplyImmediately) {
          if (this.animationFrame) {
            window.cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
          }

          this.applyParallax(true);
          return;
        }

        if (this.animationFrame) return;

        this.animationFrame = window.requestAnimationFrame(() => {
          this.animationFrame = null;
          this.applyParallax(false);
        });
      }

      applyParallax(immediate) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        let shouldContinue = false;

        this.parallaxStates.forEach((state) => {
          const section = state.section;
          const overlay = state.overlay;
          const sectionRect = section.getBoundingClientRect();
          const isRendered = section.getClientRects().length > 0 && sectionRect.height > 0;
          const isWithinBuffer = sectionRect.bottom >= -120 && sectionRect.top <= viewportHeight + 120;
          const logoHeight = overlay.getBoundingClientRect().height;

          if (!isRendered || !isWithinBuffer || !logoHeight) {
            state.currentY = 0;
            state.targetY = 0;
            overlay.style.setProperty('--giesto-editorial-parallax-y', '0px');
            overlay.classList.remove('is-visible');
            return;
          }

          const progress = Math.max(
            0,
            Math.min(1, (viewportHeight - sectionRect.top + 120) / (viewportHeight + sectionRect.height + 240))
          );
          const easedProgress = progress * progress * (3 - 2 * progress);
          state.targetY = Math.max(sectionRect.height - logoHeight, 0) * easedProgress;
          overlay.classList.add('is-visible');

          if (immediate) {
            state.currentY = state.targetY;
          } else {
            state.currentY += (state.targetY - state.currentY) * 0.16;
            if (Math.abs(state.targetY - state.currentY) > 0.1) {
              shouldContinue = true;
            } else {
              state.currentY = state.targetY;
            }
          }

          overlay.style.setProperty('--giesto-editorial-parallax-y', `${state.currentY.toFixed(2)}px`);
        });

        if (!immediate && shouldContinue) {
          this.refreshParallax(false);
        }
      }
    }

    customElements.define('giesto-editorial-pairs', GiestoEditorialPairs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-site-header')) {
    class GiestoSiteHeader extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        this.drawer = this.querySelector('[data-giesto-header-drawer]');
        this.backdrop = this.querySelector('[data-giesto-header-backdrop]');
        this.announcement = this.querySelector('.giesto-header__announcement');
        this.drawerPanels = Array.from(this.querySelectorAll('[data-giesto-header-drawer-panel]'));
        this.openTriggers = Array.from(this.querySelectorAll('[data-giesto-header-open]'));
        this.mega = this.querySelector('[data-giesto-header-mega]');
        this.megaPanels = Array.from(this.querySelectorAll('[data-giesto-header-mega-panel]'));
        this.megaSurfaces = Array.from(this.querySelectorAll('[data-giesto-header-mega-panel]'));
        this.megaTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mega-open]'));
        this.primaryNavigation = this.querySelector('.giesto-header__primary-navigation');
        this.primaryTriggers = Array.from(this.primaryNavigation?.querySelectorAll('.giesto-header__primary-trigger') || []);
        // Titles that open a mega panel are links too now, but they are not
        // "plain" links - a plain link CLOSES the panel on hover, which would
        // fight the trigger that just opened it.
        this.primaryPlainLinks = Array.from(
          this.primaryNavigation?.querySelectorAll(
            'a.giesto-header__primary-trigger:not([data-giesto-header-mega-open])'
          ) || []
        );
        this.defaultMegaTrigger = this.primaryTriggers.find((trigger) => trigger.getAttribute('aria-current') === 'page')
          || this.primaryTriggers.find((trigger) => trigger.hasAttribute('data-giesto-header-mega-default'))
          || this.megaTriggers[0]
          || this.primaryTriggers[0]
          || null;
        this.megaCategoryTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mega-category-trigger]'));
        this.megaCategoryPanels = Array.from(this.querySelectorAll('[data-giesto-header-mega-category-panel]'));
        this.megaCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-mega-close]'));
        this.mobilePanels = Array.from(this.querySelectorAll('[data-giesto-header-mobile-panel]'));
        this.mobilePanelTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mobile-open]'));
        this.mobileBackButtons = Array.from(this.querySelectorAll('[data-giesto-header-mobile-back]'));
        this.localeDialog = this.querySelector('[data-giesto-header-locale-dialog]');
        this.localeTriggers = Array.from(this.querySelectorAll('[data-giesto-header-locale-open]'));
        this.localeCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-locale-close]'));
        this.searchPanel = this.querySelector('[data-giesto-header-search-panel]');
        this.searchForms = Array.from(this.querySelectorAll('[data-giesto-header-search-form]'));
        this.searchInputs = Array.from(this.querySelectorAll('[data-giesto-header-search-input]'));
        this.searchClearButtons = Array.from(this.querySelectorAll('[data-giesto-header-search-clear]'));
        this.searchCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-search-close]'));
        this.searchStaticProducts = this.querySelector('[data-giesto-header-search-static-products]');
        this.searchDynamicProducts = this.querySelector('[data-giesto-header-search-dynamic-products]');
        this.searchDynamicResults = this.querySelector('[data-giesto-header-search-dynamic-results]');
        this.predictiveSearchUrl = this.dataset.giestoHeaderPredictiveUrl || '';
        this.predictiveSearchSection = this.dataset.giestoHeaderPredictiveSection || '';
        this.searchFuzzyLabel = this.dataset.giestoHeaderSearchFuzzyLabel || '';
        this.searchCatalogUrl = this.dataset.giestoHeaderSearchCatalogUrl || '';
        this.searchProductsUrl = this.dataset.giestoHeaderProductsUrl || '/products/';
        this.searchCatalogRequest = null;
        this.searchCatalogProducts = null;
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.megaCloseTimer = null;
        this.activeTrigger = null;
        this.lastTrigger = null;
        this.activeMegaTrigger = null;
        this.lastMegaTrigger = null;
        this.primaryPlainLinkPointer = null;
        this.primaryPlainLinkFocus = null;
        this.lastLocaleTrigger = null;
        this.lastSearchInput = null;
        this.ignoreNextSearchFocus = false;
        this.searchRequestTimer = null;
        this.searchRequestController = null;
        this.searchRequestSequence = 0;

        this.onOpenTrigger = this.onOpenTrigger.bind(this);
        this.onCloseTrigger = this.onCloseTrigger.bind(this);
        this.onCloseLink = this.onCloseLink.bind(this);
        this.onMobilePanelTrigger = this.onMobilePanelTrigger.bind(this);
        this.onMobileBack = this.onMobileBack.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        this.onDrawerCancel = this.onDrawerCancel.bind(this);
        this.onDrawerClick = this.onDrawerClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCartDrawerState = this.onCartDrawerState.bind(this);
        this.onPageHide = this.onPageHide.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onMegaTrigger = this.onMegaTrigger.bind(this);
        this.onMegaPointerEnter = this.onMegaPointerEnter.bind(this);
        this.onMegaTriggerFocus = this.onMegaTriggerFocus.bind(this);
        this.onMegaPointerLeave = this.onMegaPointerLeave.bind(this);
        this.onPrimaryPlainLinkPointerEnter = this.onPrimaryPlainLinkPointerEnter.bind(this);
        this.onPrimaryPlainLinkPointerLeave = this.onPrimaryPlainLinkPointerLeave.bind(this);
        this.onPrimaryPlainLinkFocus = this.onPrimaryPlainLinkFocus.bind(this);
        this.onPrimaryPlainLinkBlur = this.onPrimaryPlainLinkBlur.bind(this);
        this.onMegaSurfacePointerEnter = this.onMegaSurfacePointerEnter.bind(this);
        this.onMegaSurfacePointerLeave = this.onMegaSurfacePointerLeave.bind(this);
        this.onMegaCategoryTrigger = this.onMegaCategoryTrigger.bind(this);
        this.onMegaClose = this.onMegaClose.bind(this);
        this.onMegaLink = this.onMegaLink.bind(this);
        this.onLocaleOpen = this.onLocaleOpen.bind(this);
        this.onLocaleCloseButton = this.onLocaleCloseButton.bind(this);
        this.onLocaleDialogClose = this.onLocaleDialogClose.bind(this);
        this.onLocaleDialogCancel = this.onLocaleDialogCancel.bind(this);
        this.onLocaleDialogClick = this.onLocaleDialogClick.bind(this);
        this.onSearchInput = this.onSearchInput.bind(this);
        this.onSearchFocus = this.onSearchFocus.bind(this);
        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.onSearchSubmitClick = this.onSearchSubmitClick.bind(this);
        this.onSearchClear = this.onSearchClear.bind(this);
        this.onSearchClose = this.onSearchClose.bind(this);
        this.onSearchLink = this.onSearchLink.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);

        /* A bfcache/theme-editor remount can preserve an old open attribute. */
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();

        this.openTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onOpenTrigger, { signal: this.controller.signal });
        });

        this.mobilePanelTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onMobilePanelTrigger, { signal: this.controller.signal });
        });

        this.mobileBackButtons.forEach((button) => {
          button.addEventListener('click', this.onMobileBack, { signal: this.controller.signal });
        });

        this.megaTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onMegaTrigger, { signal: this.controller.signal });
          trigger.addEventListener('pointerenter', this.onMegaPointerEnter, { signal: this.controller.signal });
          trigger.addEventListener('pointerleave', this.onMegaPointerLeave, { signal: this.controller.signal });
          trigger.addEventListener('focus', this.onMegaTriggerFocus, { signal: this.controller.signal });
        });

        this.primaryPlainLinks.forEach((link) => {
          link.addEventListener('pointerenter', this.onPrimaryPlainLinkPointerEnter, { signal: this.controller.signal });
          link.addEventListener('pointerleave', this.onPrimaryPlainLinkPointerLeave, { signal: this.controller.signal });
          link.addEventListener('focus', this.onPrimaryPlainLinkFocus, { signal: this.controller.signal });
          link.addEventListener('blur', this.onPrimaryPlainLinkBlur, { signal: this.controller.signal });
        });

        this.megaSurfaces.forEach((surface) => {
          surface.addEventListener('pointerenter', this.onMegaSurfacePointerEnter, { signal: this.controller.signal });
          surface.addEventListener('pointerleave', this.onMegaSurfacePointerLeave, { signal: this.controller.signal });
        });

        this.megaCategoryTriggers.forEach((trigger) => {
          trigger.addEventListener('pointerenter', this.onMegaCategoryTrigger, { signal: this.controller.signal });
          trigger.addEventListener('focus', this.onMegaCategoryTrigger, { signal: this.controller.signal });
        });

        this.megaCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onMegaClose, { signal: this.controller.signal });
        });

        this.localeTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onLocaleOpen, { signal: this.controller.signal });
        });

        this.localeCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onLocaleCloseButton, { signal: this.controller.signal });
        });

        if (this.localeDialog) {
          this.localeDialog.addEventListener('close', this.onLocaleDialogClose, { signal: this.controller.signal });
          this.localeDialog.addEventListener('cancel', this.onLocaleDialogCancel, { signal: this.controller.signal });
          this.localeDialog.addEventListener('click', this.onLocaleDialogClick, { signal: this.controller.signal });
        }

        this.searchForms.forEach((form) => {
          form.addEventListener('submit', this.onSearchSubmit, { signal: this.controller.signal });
        });

        this.searchInputs.forEach((input) => {
          input.addEventListener('input', this.onSearchInput, { signal: this.controller.signal });
          input.addEventListener('focus', this.onSearchFocus, { signal: this.controller.signal });
          input.addEventListener('click', this.onSearchFocus, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-search-submit]').forEach((button) => {
          button.addEventListener('click', this.onSearchSubmitClick, { signal: this.controller.signal });
        });

        this.searchClearButtons.forEach((button) => {
          button.addEventListener('click', this.onSearchClear, { signal: this.controller.signal });
        });

        this.searchCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onSearchClose, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-search-link]').forEach((link) => {
          link.addEventListener('click', this.onSearchLink, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-mega-link]').forEach((link) => {
          link.addEventListener('click', this.onMegaLink, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-close]').forEach((trigger) => {
          trigger.addEventListener('click', this.onCloseTrigger, { signal: this.controller.signal });
        });

        this.backdrop?.addEventListener('click', this.onCloseTrigger, { signal: this.controller.signal });

        this.querySelectorAll('[data-giesto-header-close-link]').forEach((link) => {
          link.addEventListener('click', this.onCloseLink, { signal: this.controller.signal });
        });

        if (this.drawer) {
          this.drawer.addEventListener('close', this.onDrawerClose, { signal: this.controller.signal });
          this.drawer.addEventListener('cancel', this.onDrawerCancel, { signal: this.controller.signal });
          this.drawer.addEventListener('click', this.onDrawerClick, { signal: this.controller.signal });
        }

        document.addEventListener('theme-drawer:open', this.onCartDrawerState, { signal: this.controller.signal });
        document.addEventListener('theme-drawer:close', this.onCartDrawerState, { signal: this.controller.signal });
        document.addEventListener('keydown', this.onKeydown, { signal: this.controller.signal });
        document.addEventListener('pointerdown', this.onDocumentPointerDown, { signal: this.controller.signal });
        window.addEventListener('pagehide', this.onPageHide, { signal: this.controller.signal });
        window.addEventListener('pageshow', this.onPageShow, { signal: this.controller.signal });
        this.desktopMedia.addEventListener('change', this.onBreakpointChange, { signal: this.controller.signal });
        this.syncAnnouncementHeight();
        if ('ResizeObserver' in window && this.announcement) {
          this.announcementObserver = new ResizeObserver(() => this.syncAnnouncementHeight());
          this.announcementObserver.observe(this.announcement);
        }
        this.setActivePanel('all');
        this.syncSearchClearButtons();
        this.syncCartDrawerState();
        this.syncHeaderState();
      }

      disconnectedCallback() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
        this.announcementObserver?.disconnect();
        this.announcementObserver = null;
        this.controller?.abort();
      }

      isDesktop() {
        return Boolean(this.desktopMedia?.matches);
      }

      syncAnnouncementHeight() {
        if (this.closest('#header-group')?.hasAttribute('data-condensed')) return;
        const height = Math.max(this.announcement?.offsetHeight || 0, this.announcement?.scrollHeight || 0);
        this.style.setProperty('--giesto-header-announcement-height', `${height}px`);
      }

      onLocaleOpen(event) {
        event.preventDefault();
        if (!this.localeDialog) return;

        this.lastLocaleTrigger = event.currentTarget;
        this.closeSearch(false);
        this.closeMega(false);
        if (this.drawer?.open) this.closeDrawer(false);

        if (!this.localeDialog.open) {
          try {
            this.localeDialog.showModal();
          } catch (error) {
            this.resetLocaleState();
            return;
          }
        }

        this.syncLocaleState();
        window.requestAnimationFrame(() => {
          const selectedOption = this.localeDialog?.querySelector('.giesto-header__locale-option.is-current');
          const closeButton = this.localeDialog?.querySelector('[data-giesto-header-locale-close]');
          (selectedOption || closeButton)?.focus({ preventScroll: true });
        });
      }

      onLocaleDialogClose() {
        const returnFocus = this.localeDialog?.dataset.giestoHeaderLocaleReturnFocus !== 'false';
        if (this.localeDialog) delete this.localeDialog.dataset.giestoHeaderLocaleReturnFocus;
        const trigger = this.lastLocaleTrigger;
        this.lastLocaleTrigger = null;
        this.syncLocaleState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      onLocaleCloseButton() {
        this.closeLocaleDialog(true);
      }

      onLocaleDialogCancel() {
        if (this.localeDialog) this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = 'true';
      }

      onLocaleDialogClick(event) {
        if (event.target === this.localeDialog) this.closeLocaleDialog(true);
      }

      closeLocaleDialog(returnFocus) {
        if (!this.localeDialog?.open) {
          this.resetLocaleState();
          return;
        }

        this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = returnFocus ? 'true' : 'false';
        this.localeDialog.close();
      }

      resetLocaleState() {
        if (this.localeDialog?.open) {
          this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = 'false';
          this.localeDialog.close();
        }

        this.localeDialog?.removeAttribute('open');
        this.lastLocaleTrigger = null;
        this.localeTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.classList.remove('is-locale-open');
      }

      syncLocaleState() {
        const localeOpen = Boolean(this.localeDialog?.open);
        this.classList.toggle('is-locale-open', localeOpen);
        this.localeTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', localeOpen ? 'true' : 'false'));
      }

      onSearchInput(event) {
        const input = event.currentTarget;
        this.lastSearchInput = input;
        this.syncSearchQuery(input);
        this.openSearch(input, false);
        this.queuePredictiveSearch(input.value);
      }

      onSearchFocus(event) {
        if (this.ignoreNextSearchFocus) {
          this.ignoreNextSearchFocus = false;
          return;
        }
        const input = event.currentTarget;
        this.openSearch(input, false);
        if (input.value.trim()) this.queuePredictiveSearch(input.value);
      }

      onSearchSubmitClick(event) {
        if (this.isSearchOpen()) return;
        event.preventDefault();
        const form = event.currentTarget.closest('[data-giesto-header-search-form]');
        const input = form?.querySelector('[data-giesto-header-search-input]');
        this.openSearch(input, true);
      }

      onSearchSubmit(event) {
        const input = event.currentTarget.querySelector('[data-giesto-header-search-input]');
        if (input?.value.trim()) return;
        event.preventDefault();
        this.openSearch(input, true);
      }

      onSearchClear(event) {
        const form = event.currentTarget?.closest('[data-giesto-header-search-form]');
        const input = form?.querySelector('[data-giesto-header-search-input]');
        if (!input) return;

        input.value = '';
        this.lastSearchInput = input;
        this.syncSearchQuery(input);
        this.resetPredictiveSearch();
        this.ignoreNextSearchFocus = true;
        input.focus({ preventScroll: true });
      }

      onSearchClose() {
        this.closeSearch(true);
      }

      onSearchLink() {
        this.closeSearch(false);
      }

      isSearchOpen() {
        return Boolean(this.searchPanel && !this.searchPanel.hidden);
      }

      openSearch(input, shouldFocus) {
        if (!this.searchPanel) return;

        this.closeMega(false);
        this.closeDrawer(false);
        this.lastSearchInput = input || this.lastSearchInput || this.searchInputs[0] || null;
        this.searchPanel.hidden = false;
        if (!this.lastSearchInput?.value.trim()) this.resetPredictiveSearch();
        this.syncSearchState();

        if (shouldFocus && this.lastSearchInput) {
          window.requestAnimationFrame(() => {
            this.lastSearchInput?.focus({ preventScroll: true });
          });
        }
      }

      closeSearch(returnFocus) {
        const input = this.lastSearchInput || this.searchInputs[0] || null;
        if (this.searchPanel) this.searchPanel.hidden = true;
        this.resetPredictiveSearch();
        this.searchInputs.forEach((searchInput) => {
          searchInput.value = '';
        });
        this.syncSearchState();
        if (returnFocus && input && document.activeElement !== input) {
          this.ignoreNextSearchFocus = true;
          input.focus({ preventScroll: true });
        }
      }

      resetSearchState() {
        if (this.searchPanel) this.searchPanel.hidden = true;
        this.resetPredictiveSearch();
        this.lastSearchInput = null;
        this.ignoreNextSearchFocus = false;
        this.syncSearchState();
      }

      syncSearchState() {
        const searchOpen = this.isSearchOpen();
        this.classList.toggle('is-search-open', searchOpen);
        this.searchInputs?.forEach((input) => input.setAttribute('aria-expanded', searchOpen ? 'true' : 'false'));
        this.syncSearchClearButtons();
      }

      syncSearchQuery(source) {
        this.searchInputs.forEach((input) => {
          if (input !== source) input.value = source.value;
        });
        this.syncSearchClearButtons();
      }

      syncSearchClearButtons() {
        this.searchClearButtons?.forEach((button) => {
          const input = button.closest('[data-giesto-header-search-form]')?.querySelector('[data-giesto-header-search-input]');
          button.hidden = !input?.value.trim();
        });
      }

      queuePredictiveSearch(value) {
        const query = value.trim();

        if (!query) {
          this.resetPredictiveSearch();
          return;
        }

        if (!this.searchDynamicProducts || !this.searchDynamicResults || !this.predictiveSearchUrl || !this.predictiveSearchSection) {
          return;
        }

        if (this.searchRequestTimer) window.clearTimeout(this.searchRequestTimer);
        this.searchRequestController?.abort();
        this.searchRequestSequence += 1;

        const requestSequence = this.searchRequestSequence;
        this.searchStaticProducts?.setAttribute('hidden', '');
        this.searchDynamicProducts.hidden = false;
        this.searchDynamicProducts.setAttribute('aria-busy', 'true');
        this.searchDynamicResults.setAttribute('aria-busy', 'true');
        this.searchDynamicResults.replaceChildren();

        this.searchRequestTimer = window.setTimeout(() => {
          this.fetchPredictiveSearch(query, requestSequence);
        }, 220);
      }

      async fetchPredictiveSearch(query, requestSequence) {
        this.searchRequestTimer = null;
        const controller = new AbortController();
        this.searchRequestController = controller;

        try {
          const url = new URL(this.predictiveSearchUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '4');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][prefix]', 'last');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          url.searchParams.set('section_id', this.predictiveSearchSection);

          const response = await fetch(url, {
            signal: controller.signal,
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) throw new Error(`Predictive search request failed: ${response.status}`);

          const markup = await response.text();
          if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;

          const documentMarkup = new DOMParser().parseFromString(markup, 'text/html');
          const cards = documentMarkup.querySelector('[data-giesto-header-predictive-cards]');

          if (cards?.dataset.predictiveSearchState === 'empty') {
            const fuzzyProducts = await this.getFuzzySearchProducts(query);
            if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;

            if (fuzzyProducts.length) {
              this.renderFuzzySearchResults(query, fuzzyProducts);
            } else {
              this.searchDynamicResults.replaceChildren(cards.cloneNode(true));
            }
          } else if (cards) {
            this.searchDynamicResults.replaceChildren(cards.cloneNode(true));
          } else {
            this.renderPredictiveSearchEmptyState();
          }
        } catch (error) {
          if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;
          const fuzzyProducts = await this.getFuzzySearchProducts(query);
          if (requestSequence !== this.searchRequestSequence) return;

          if (fuzzyProducts.length) {
            this.renderFuzzySearchResults(query, fuzzyProducts);
          } else {
            this.renderPredictiveSearchEmptyState();
          }
        } finally {
          if (requestSequence === this.searchRequestSequence) {
            this.searchDynamicProducts?.setAttribute('aria-busy', 'false');
            this.searchDynamicResults?.setAttribute('aria-busy', 'false');
            this.searchRequestController = null;
          }
        }
      }

      renderPredictiveSearchEmptyState() {
        if (!this.searchDynamicResults) return;
        const message = document.createElement('p');
        message.className = 'giesto-header__search-no-results';
        message.textContent = this.dataset.giestoHeaderSearchNoResults || '';
        this.searchDynamicResults.replaceChildren(message);
      }

      async getFuzzySearchProducts(query) {
        const normalizedQuery = this.normalizeSearchText(query);
        const queryTokens = normalizedQuery.split(' ').filter((token) => token.length >= 2);

        if (!queryTokens.length || !this.searchCatalogUrl) return [];

        const products = await this.getSearchCatalogProducts();
        if (!products.length) return [];

        return products
          .filter((product) => this.isSearchCatalogProductAvailable(product))
          .map((product, index) => ({
            product,
            index,
            score: this.getFuzzyProductScore(product, queryTokens),
          }))
          .filter(({ score }) => score > 0)
          .sort((first, second) => second.score - first.score || first.index - second.index)
          .slice(0, 4)
          .map(({ product }) => product);
      }

      async getSearchCatalogProducts() {
        if (Array.isArray(this.searchCatalogProducts)) return this.searchCatalogProducts;
        if (!this.searchCatalogUrl) return [];

        if (!this.searchCatalogRequest) {
          this.searchCatalogRequest = fetch(this.searchCatalogUrl, {
            headers: { Accept: 'application/json' },
          })
            .then((response) => (response.ok ? response.json() : null))
            .then((payload) => {
              const products = Array.isArray(payload?.products) ? payload.products : [];
              this.searchCatalogProducts = products;
              return products;
            })
            .catch(() => {
              this.searchCatalogRequest = null;
              this.searchCatalogProducts = null;
              return [];
            });
        }

        return this.searchCatalogRequest;
      }

      isSearchCatalogProductAvailable(product) {
        if (product?.available === false) return false;

        const variants = Array.isArray(product?.variants) ? product.variants : [];
        return !variants.length || variants.some((variant) => variant?.available !== false);
      }

      normalizeSearchText(value) {
        return String(value || '')
          .toLocaleLowerCase('tr-TR')
          .replace(/ı/g, 'i')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      getFuzzyProductScore(product, queryTokens) {
        const variants = Array.isArray(product?.variants) ? product.variants : [];
        const tags = Array.isArray(product?.tags) ? product.tags.join(' ') : product?.tags;
        const searchableFields = [
          { value: product?.title, weight: 400 },
          { value: product?.product_type, weight: 280 },
          { value: variants.map((variant) => variant?.title).join(' '), weight: 240 },
          { value: tags, weight: 140 },
        ];

        let totalScore = 0;

        for (const queryToken of queryTokens) {
          let tokenScore = 0;

          for (const field of searchableFields) {
            const productTokens = this.normalizeSearchText(field.value).split(' ').filter(Boolean);

            for (const productToken of productTokens) {
              if (productToken.startsWith(queryToken)) {
                tokenScore = Math.max(tokenScore, field.weight + 40 + queryToken.length);
                continue;
              }

              if (queryToken.length >= 3 && productToken.includes(queryToken)) {
                tokenScore = Math.max(tokenScore, field.weight + 20 + queryToken.length);
                continue;
              }

              if (productToken[0] !== queryToken[0] || productToken.length < queryToken.length) continue;

              const productPrefix = productToken.slice(0, queryToken.length);
              const distance = this.getSearchEditDistance(queryToken, productPrefix);
              if (distance <= 1) tokenScore = Math.max(tokenScore, field.weight - 20 * distance + queryToken.length);
            }
          }

          if (!tokenScore) return 0;
          totalScore += tokenScore;
        }

        return totalScore;
      }

      getSearchEditDistance(firstValue, secondValue) {
        let beforePrevious = null;
        let previous = Array.from({ length: secondValue.length + 1 }, (_, index) => index);

        for (let firstIndex = 1; firstIndex <= firstValue.length; firstIndex += 1) {
          const current = [firstIndex];

          for (let secondIndex = 1; secondIndex <= secondValue.length; secondIndex += 1) {
            const cost = firstValue[firstIndex - 1] === secondValue[secondIndex - 1] ? 0 : 1;
            let distance = Math.min(
              previous[secondIndex] + 1,
              current[secondIndex - 1] + 1,
              previous[secondIndex - 1] + cost,
            );

            if (
              firstIndex > 1
              && secondIndex > 1
              && firstValue[firstIndex - 1] === secondValue[secondIndex - 2]
              && firstValue[firstIndex - 2] === secondValue[secondIndex - 1]
            ) {
              distance = Math.min(distance, beforePrevious[secondIndex - 2] + 1);
            }

            current[secondIndex] = distance;
          }

          beforePrevious = previous;
          previous = current;
        }

        return previous[secondValue.length];
      }

      renderFuzzySearchResults(query, products) {
        if (!this.searchDynamicResults) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'giesto-header__search-fuzzy-results';
        const message = document.createElement('p');
        message.className = 'giesto-header__search-fuzzy-message';
        message.setAttribute('role', 'status');
        message.textContent = this.searchFuzzyLabel || 'Benzer ürünler';

        const grid = document.createElement('div');
        grid.className = 'giesto-header__search-product-grid giesto-header__search-product-grid--predictive';
        grid.setAttribute('role', 'list');

        products.forEach((product) => {
          const card = document.createElement('a');
          const imageSource = typeof product.featured_image === 'string'
            ? product.featured_image
            : product.featured_image?.src || product.images?.[0]?.src || '';

          card.className = 'giesto-header__search-product';
          card.href = product.url || `${this.searchProductsUrl}${encodeURIComponent(product.handle || '')}`;
          card.setAttribute('aria-label', product.title || query);
          card.setAttribute('data-giesto-header-search-link', '');

          const media = document.createElement('span');
          media.className = 'giesto-header__search-product-media';
          media.setAttribute('aria-hidden', 'true');

          if (imageSource) {
            const image = document.createElement('img');
            image.className = 'giesto-header__search-product-image';
            image.src = imageSource;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            media.append(image);
          }

          card.append(media);
          grid.append(card);
        });

        wrapper.append(message, grid);
        this.searchDynamicResults.replaceChildren(wrapper);
      }

      resetPredictiveSearch() {
        if (this.searchRequestTimer) window.clearTimeout(this.searchRequestTimer);
        this.searchRequestTimer = null;
        this.searchRequestController?.abort();
        this.searchRequestController = null;
        this.searchRequestSequence += 1;
        this.searchStaticProducts?.removeAttribute('hidden');
        if (this.searchDynamicProducts) {
          this.searchDynamicProducts.hidden = true;
          this.searchDynamicProducts.setAttribute('aria-busy', 'false');
        }
        this.searchDynamicResults?.replaceChildren();
      }

      onOpenTrigger(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        const trigger = event.currentTarget;
        const panel = trigger.dataset.giestoHeaderPanel || 'all';

        if (!this.drawer) return;

        if (this.drawer.open && this.activeTrigger === trigger) {
          this.closeDrawer(true);
          return;
        }

        this.closeSearch(false);
        this.closeMega(false);
        this.lastTrigger = trigger;
        this.activeTrigger = trigger;
        this.setActivePanel(panel);
        this.resetMobilePanelState();

        if (!this.drawer.open) {
          try {
            this.drawer.show();
          } catch (error) {
            this.resetDrawerState();
            return;
          }
        }
        this.syncHeaderState();

        window.requestAnimationFrame(() => {
          const firstMenuItem = this.mobilePanels
            ?.find((mobilePanel) => mobilePanel.dataset.giestoHeaderMobilePanel === 'root')
            ?.querySelector('[data-giesto-header-mobile-open], a[href]');
          (firstMenuItem || trigger).focus({ preventScroll: true });
        });
      }

      onMobilePanelTrigger(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        this.setMobilePanel(event.currentTarget?.dataset.giestoHeaderMobileOpen, true);
      }

      onMobileBack(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        this.setMobilePanel(event.currentTarget?.dataset.giestoHeaderMobileBack, true);
      }

      onMegaTrigger(event) {
        if (!this.isDesktop()) return;

        const trigger = event.currentTarget;

        // With a hovering pointer the panel is already open by the time the
        // click lands, so the click belongs to the link and navigates. Without
        // hover - touch on a wide screen - the click is the only way into the
        // panel, so it keeps opening it instead.
        if (trigger instanceof HTMLAnchorElement && trigger.href && this.hoverMedia.matches) return;

        event.preventDefault();

        if (!this.mega.hidden && this.activeMegaTrigger === trigger) {
          this.closeMega(true);
          return;
        }

        this.openMega(trigger);
      }

      onMegaPointerEnter(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.clearMegaCloseTimer();
        this.openMega(event.currentTarget);
      }

      /**
       * Keyboard route into the panel. Enter on a link now navigates, so focus
       * has to be what opens it. Gated on :focus-visible so a mouse click does
       * not flash the panel open on its way to the destination.
       */
      onMegaTriggerFocus(event) {
        if (!this.isDesktop()) return;

        const trigger = event.currentTarget;
        if (!(trigger instanceof HTMLElement) || !trigger.matches(':focus-visible')) return;

        this.clearMegaCloseTimer();
        this.openMega(trigger);
      }

      onMegaPointerLeave() {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.queueMegaClose();
      }

      onPrimaryPlainLinkPointerEnter(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.clearMegaCloseTimer();
        this.primaryPlainLinkPointer = event.currentTarget;
        if (!this.mega?.hidden) this.closeMega(false);
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkPointerLeave(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        if (this.primaryPlainLinkPointer !== event.currentTarget) return;
        this.primaryPlainLinkPointer = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkFocus(event) {
        if (!this.isDesktop()) return;
        this.primaryPlainLinkFocus = event.currentTarget;
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkBlur(event) {
        if (this.primaryPlainLinkFocus !== event.currentTarget) return;
        this.primaryPlainLinkFocus = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      syncPrimaryPlainLinkInteraction() {
        const activeLink = this.primaryPlainLinkPointer || this.primaryPlainLinkFocus;
        this.classList.toggle('is-primary-link-interacting', Boolean(activeLink));
        this.primaryPlainLinks?.forEach((link) => {
          link.classList.toggle('is-primary-link-interacting', link === activeLink);
        });
      }

      clearPrimaryPlainLinkInteraction() {
        this.primaryPlainLinkPointer = null;
        this.primaryPlainLinkFocus = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      onMegaSurfacePointerEnter() {
        this.clearMegaCloseTimer();
      }

      onMegaSurfacePointerLeave() {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.queueMegaClose();
      }

      onMegaCategoryTrigger(event) {
        if (!this.isDesktop()) return;
        this.clearMegaCloseTimer();
        this.setActiveMegaCategory(event.currentTarget);
      }

      onMegaClose() {
        this.closeMega(true);
      }

      openMega(trigger) {
        const panel = trigger?.dataset.giestoHeaderMegaPanel;
        if (!panel || !this.mega) return;

        this.clearMegaCloseTimer();
        this.lastMegaTrigger = trigger;
        this.activeMegaTrigger = trigger;
        this.setSelectedMegaTrigger(trigger);
        this.setActiveMegaPanel(panel);
        this.mega.hidden = false;
        this.syncMegaState();
      }

      queueMegaClose() {
        this.clearMegaCloseTimer();
        this.megaCloseTimer = window.setTimeout(() => {
          this.megaCloseTimer = null;
          this.closeMega(false);
        }, 260);
      }

      clearMegaCloseTimer() {
        if (this.megaCloseTimer === null) return;
        window.clearTimeout(this.megaCloseTimer);
        this.megaCloseTimer = null;
      }

      onMegaLink() {
        this.closeMega(false);
      }

      onDocumentPointerDown(event) {
        const target = event.target;
        if (!(target instanceof Node)) return;

        if (this.isSearchOpen() && !this.contains(target)) {
          this.closeSearch(false);
        }

        if (!this.isDesktop() || this.mega?.hidden) return;

        const hitMega = this.mega?.contains(target);
        const hitTrigger = this.megaTriggers.some((trigger) => trigger.contains(target));

        if (!hitMega && !hitTrigger) this.closeMega(false);
      }

      onBreakpointChange() {
        this.resetMegaState();
        this.resetDrawerState();
        this.resetMobilePanelState();
        this.resetSearchState();
      }

      onCloseTrigger() {
        this.closeDrawer(true);
      }

      onCloseLink() {
        this.closeDrawer(false);
      }

      onDrawerClose() {
        const returnFocus = this.drawer?.dataset.giestoHeaderReturnFocus !== 'false';
        if (this.drawer) delete this.drawer.dataset.giestoHeaderReturnFocus;
        const trigger = this.lastTrigger;
        this.activeTrigger = null;
        this.resetMobilePanelState();
        if (this.backdrop) this.backdrop.hidden = true;
        this.syncHeaderState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      onDrawerCancel() {
        if (this.drawer) this.drawer.dataset.giestoHeaderReturnFocus = 'true';
      }

      onDrawerClick(event) {
        if (event.target === this.drawer) this.closeDrawer(true);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        if (this.localeDialog?.open) {
          event.preventDefault();
          this.closeLocaleDialog(true);
          return;
        }

        if (this.isSearchOpen()) {
          event.preventDefault();
          this.closeSearch(true);
          return;
        }

        if (this.isDesktop() && !this.mega?.hidden) {
          event.preventDefault();
          this.closeMega(true);
          return;
        }

        if (this.drawer?.open) {
          event.preventDefault();
          this.closeDrawer(true);
        }
      }

      onPageHide() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
      }

      onPageShow() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
      }

      onCartDrawerState(event) {
        if (event.target?.id !== 'cart-drawer') return;
        if (event.type === 'theme-drawer:open') {
          this.closeMega(false);
          this.closeDrawer(false);
          this.closeSearch(false);
          this.closeLocaleDialog(false);
        }
        this.syncCartDrawerState();
      }

      setActivePanel(panel) {
        if (!this.drawer) return;
        this.drawer.dataset.activePanel = panel;
        this.drawerPanels.forEach((drawerPanel) => {
          drawerPanel.hidden = panel !== 'all' && drawerPanel.dataset.giestoHeaderDrawerPanel !== panel;
        });
      }

      setActiveMegaPanel(panel) {
        if (!this.mega) return;
        this.mega.dataset.activePanel = panel;
        this.megaPanels.forEach((megaPanel) => {
          megaPanel.hidden = megaPanel.dataset.giestoHeaderMegaPanel !== panel;
          if (!megaPanel.hidden) this.resetMegaCategory(megaPanel);
        });
      }

      setSelectedMegaTrigger(trigger) {
        if (!this.primaryTriggers?.length || !trigger) return;

        this.primaryTriggers.forEach((candidate) => {
          candidate.classList.toggle('is-mega-selected', candidate === trigger);
        });
      }

      setActiveMegaCategory(trigger) {
        const megaPanel = trigger?.closest('[data-giesto-header-mega-panel]');
        const categoryId = trigger?.dataset.giestoHeaderMegaCategory;
        if (!megaPanel || !categoryId) return;

        this.megaCategoryTriggers.forEach((candidate) => {
          if (candidate.closest('[data-giesto-header-mega-panel]') !== megaPanel) return;
          candidate.classList.toggle('is-active', candidate === trigger);
        });

        this.megaCategoryPanels.forEach((categoryPanel) => {
          if (categoryPanel.closest('[data-giesto-header-mega-panel]') !== megaPanel) return;
          categoryPanel.hidden = categoryPanel.dataset.giestoHeaderMegaCategoryPanel !== categoryId;
        });
      }

      resetMegaCategory(megaPanel) {
        const defaultCategoryId = megaPanel?.dataset.giestoHeaderMegaDefaultCategory;
        if (!defaultCategoryId) return;

        this.megaCategoryTriggers.forEach((trigger) => {
          if (trigger.closest('[data-giesto-header-mega-panel]') === megaPanel) {
            trigger.classList.toggle('is-active', trigger.dataset.giestoHeaderMegaCategory === defaultCategoryId);
          }
        });

        this.megaCategoryPanels.forEach((categoryPanel) => {
          if (categoryPanel.closest('[data-giesto-header-mega-panel]') === megaPanel) {
            categoryPanel.hidden = categoryPanel.dataset.giestoHeaderMegaCategoryPanel !== defaultCategoryId;
          }
        });
      }

      setMobilePanel(panelId, moveFocus = false) {
        if (!panelId || !this.mobilePanels?.length) return;

        const nextPanel = this.mobilePanels.find(
          (mobilePanel) => mobilePanel.dataset.giestoHeaderMobilePanel === panelId,
        );
        if (!nextPanel) return;

        this.mobilePanels.forEach((mobilePanel) => {
          mobilePanel.hidden = mobilePanel !== nextPanel;
        });

        this.mobilePanelTriggers?.forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            trigger.dataset.giestoHeaderMobileOpen === panelId ? 'true' : 'false',
          );
        });

        if (this.drawer) this.drawer.dataset.giestoHeaderMobilePanel = panelId;

        if (!moveFocus) return;
        window.requestAnimationFrame(() => {
          const focusTarget = nextPanel.querySelector(
            '[data-giesto-header-mobile-back], [data-giesto-header-mobile-open], a[href]',
          );
          focusTarget?.focus({ preventScroll: true });
        });
      }

      resetMobilePanelState() {
        this.setMobilePanel('root');
      }

      closeMega(returnFocus) {
        this.clearMegaCloseTimer();
        if (!this.mega || this.mega.hidden) {
          this.resetMegaState();
          return;
        }

        const trigger = this.lastMegaTrigger;
        this.mega.hidden = true;
        this.activeMegaTrigger = null;
        this.syncMegaState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      resetMegaState() {
        this.clearMegaCloseTimer();
        if (!this.mega) return;
        this.clearPrimaryPlainLinkInteraction();
        this.mega.hidden = true;
        this.mega.setAttribute('aria-hidden', 'true');
        this.activeMegaTrigger = null;
        this.lastMegaTrigger = null;
        this.setSelectedMegaTrigger(this.defaultMegaTrigger);
        this.classList.remove('is-mega-open');
        this.megaTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.megaPanels?.forEach((megaPanel, index) => {
          megaPanel.hidden = index !== 0;
          this.resetMegaCategory(megaPanel);
        });
      }

      syncMegaState() {
        const megaOpen = Boolean(this.isDesktop() && this.mega && !this.mega.hidden);
        this.classList.toggle('is-mega-open', megaOpen);
        if (this.mega) this.mega.setAttribute('aria-hidden', megaOpen ? 'false' : 'true');
        this.megaTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', megaOpen && trigger === this.activeMegaTrigger ? 'true' : 'false');
        });
      }

      closeDrawer(returnFocus) {
        if (!this.drawer?.open) {
          this.resetDrawerState();
          return;
        }
        this.drawer.dataset.giestoHeaderReturnFocus = returnFocus ? 'true' : 'false';
        this.drawer.close();
      }

      resetDrawerState() {
        if (this.drawer?.open) {
          this.drawer.dataset.giestoHeaderReturnFocus = 'false';
          this.drawer.close();
        }

        this.drawer?.removeAttribute('open');
        if (this.backdrop) this.backdrop.hidden = true;
        this.activeTrigger = null;
        this.lastTrigger = null;
        this.resetMobilePanelState();
        this.classList.remove('is-menu-open');
        this.openTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.syncHeaderState();
      }

      syncHeaderState() {
        const drawerOpen = Boolean(this.drawer?.open);
        this.classList.toggle('is-menu-open', drawerOpen);
        if (this.backdrop) this.backdrop.hidden = !drawerOpen;
        this.syncDocumentScrollLock();
        this.openTriggers?.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', drawerOpen && trigger === this.activeTrigger ? 'true' : 'false');
          const label = drawerOpen ? trigger.dataset.giestoHeaderCloseLabel : trigger.dataset.giestoHeaderMenuLabel;
          if (label) trigger.setAttribute('aria-label', label);
        });
      }

      syncDocumentScrollLock() {
        /*
         * This drawer is fixed below the sticky header and owns its own scroll
         * area. Locking html, body, or .page-wrapper would create a new sticky
         * containing block while the page is scrolled, which moves the header
         * out of view after the announcement bar has condensed.
         */
        document.documentElement.classList.remove('giesto-header-scroll-locked');
      }

      syncCartDrawerState() {
        const trigger = this.querySelector('[data-giesto-header-cart-trigger]');
        const drawer = document.getElementById('cart-drawer');
        if (trigger && drawer) trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
      }
    }

    customElements.define('giesto-site-header', GiestoSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.GiestoLookbookCarousel) {
      const selector = '[data-giesto-lookbook-carousel]';

      const getBehavior = () => {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      };

      const setup = (root) => {
        if (!(root instanceof HTMLElement) || root._giestoLookbookCleanup) return;

        const track = root.querySelector('[data-giesto-lookbook-track]');
        if (!(track instanceof HTMLElement)) return;

        const controller = new AbortController();
        let dragState;
        let clickSuppressed = false;
        let suppressionTimer = 0;

        const getMaximum = () => Math.max(0, track.scrollWidth - track.clientWidth);

        const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

        const scrollByCard = (direction) => {
          const item = track.querySelector('.giesto-lookbook-carousel__item');
          const amount = item instanceof HTMLElement ? item.getBoundingClientRect().width : track.clientWidth;
          track.scrollBy({ left: direction * amount, behavior: getBehavior() });
        };

        const scrollToEdge = (position) => {
          track.scrollTo({ left: position, behavior: getBehavior() });
        };

        track.addEventListener(
          'wheel',
          (event) => {
            const horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            const delta = horizontalIntent ? event.deltaX : event.shiftKey ? event.deltaY : 0;
            if (!delta) return;

            const nextPosition = clamp(track.scrollLeft + delta, 0, getMaximum());
            if (Math.abs(nextPosition - track.scrollLeft) < 0.5) return;

            event.preventDefault();
            track.scrollLeft = nextPosition;
          },
          { passive: false, signal: controller.signal }
        );

        const endDrag = (event) => {
          const activeDrag = dragState;
          if (!activeDrag) return;
          if (event && event.pointerId !== activeDrag.pointerId) return;

          dragState = undefined;
          track.removeAttribute('data-giesto-dragging');

          if (track.hasPointerCapture?.(activeDrag.pointerId)) {
            track.releasePointerCapture(activeDrag.pointerId);
          }

          if (activeDrag.moved) {
            clickSuppressed = true;
            window.clearTimeout(suppressionTimer);
            suppressionTimer = window.setTimeout(() => {
              clickSuppressed = false;
            }, 0);
          }
        };

        track.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType === 'touch' || event.button !== 0) return;
            if (event.target.closest?.('button, input, select, textarea')) return;

            dragState = {
              pointerId: event.pointerId,
              startX: event.clientX,
              startScrollLeft: track.scrollLeft,
              moved: false,
            };
            track.setPointerCapture?.(event.pointerId);
          },
          { signal: controller.signal }
        );

        track.addEventListener(
          'pointermove',
          (event) => {
            if (!dragState || event.pointerId !== dragState.pointerId) return;

            const distance = event.clientX - dragState.startX;
            if (!dragState.moved && Math.abs(distance) < 4) return;

            dragState.moved = true;
            track.dataset.giestoDragging = 'true';
            track.scrollLeft = clamp(dragState.startScrollLeft - distance, 0, getMaximum());
            event.preventDefault();
          },
          { passive: false, signal: controller.signal }
        );

        track.addEventListener('pointerup', endDrag, { signal: controller.signal });
        track.addEventListener('pointercancel', endDrag, { signal: controller.signal });
        track.addEventListener('lostpointercapture', endDrag, { signal: controller.signal });
        track.addEventListener('dragstart', (event) => event.preventDefault(), { signal: controller.signal });

        track.addEventListener(
          'click',
          (event) => {
            if (!clickSuppressed) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            clickSuppressed = false;
          },
          { capture: true, signal: controller.signal }
        );

        track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== track) return;

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              scrollByCard(-1);
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              scrollByCard(1);
            }

            if (event.key === 'Home') {
              event.preventDefault();
              scrollToEdge(0);
            }

            if (event.key === 'End') {
              event.preventDefault();
              scrollToEdge(getMaximum());
            }
          },
          { signal: controller.signal }
        );

        /* ---------- Autoplay ----------

           Advances one card at a time and wraps at the end, so the row visibly
           moves on its own - a static track gives no hint that it scrolls at
           all. Every tick is gated rather than the timer being torn down and
           rebuilt: one check every few seconds is cheaper than juggling timer
           state across five different pause conditions. */
        const autoplayInterval = Number(root.dataset.giestoAutoplay) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const hoverMedia = window.matchMedia('(hover: hover)');

        let autoplayTimer = 0;
        let autoplayObserver;
        let pointerInside = false;
        let focusInside = false;
        let onScreen = true;

        const canAutoplay = () =>
          autoplayInterval > 0
          && !reduceMotion.matches
          && !document.hidden
          && onScreen
          && !pointerInside
          && !focusInside
          && !dragState
          && getMaximum() > 1;

        const autoplayStep = () => {
          if (!canAutoplay()) return;

          const maximum = getMaximum();

          // 2px of slack: scrollLeft is fractional on zoomed and HiDPI layouts
          // and never lands exactly on the maximum, so an equality test would
          // leave the carousel stuck against the end.
          if (track.scrollLeft >= maximum - 2) {
            scrollToEdge(0);
            return;
          }

          scrollByCard(1);
        };

        if (autoplayInterval > 0) {
          autoplayTimer = window.setInterval(autoplayStep, autoplayInterval);

          // Hover only pauses where hovering is a real state; on touch a
          // pointerenter can arrive without a matching leave and would park the
          // carousel for good.
          root.addEventListener(
            'pointerenter',
            () => {
              if (hoverMedia.matches) pointerInside = true;
            },
            { signal: controller.signal }
          );
          root.addEventListener(
            'pointerleave',
            () => {
              pointerInside = false;
            },
            { signal: controller.signal }
          );

          root.addEventListener(
            'focusin',
            () => {
              focusInside = true;
            },
            { signal: controller.signal }
          );
          root.addEventListener(
            'focusout',
            () => {
              focusInside = false;
            },
            { signal: controller.signal }
          );

          if ('IntersectionObserver' in window) {
            autoplayObserver = new IntersectionObserver(
              (entries) => {
                onScreen = entries.some((entry) => entry.isIntersecting);
              },
              { threshold: 0.2 }
            );
            autoplayObserver.observe(root);
          }
        }

        root._giestoLookbookCleanup = () => {
          endDrag();
          controller.abort();
          window.clearTimeout(suppressionTimer);
          window.clearInterval(autoplayTimer);
          autoplayObserver?.disconnect();
          delete root._giestoLookbookCleanup;
        };
      };

      const initialise = (context = document) => {
        if (context instanceof HTMLElement && context.matches(selector)) setup(context);
        context.querySelectorAll?.(selector).forEach(setup);
      };

      const destroy = (context = document) => {
        if (context instanceof HTMLElement && context.matches(selector)) context._giestoLookbookCleanup?.();
        context.querySelectorAll?.(selector).forEach((root) => root._giestoLookbookCleanup?.());
      };

      window.GiestoLookbookCarousel = { initialise, destroy };

      document.addEventListener('shopify:section:load', (event) => initialise(event.target));
      document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    }

    window.GiestoLookbookCarousel.initialise();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-media-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-media-banner')) {
    class GiestoMediaBanner extends HTMLElement {
      connectedCallback() {
        this.teardown();

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        this.parallaxStates = [];
        this.onScroll = this.handleScroll.bind(this);
        this.onMotionChange = this.handleMotionChange.bind(this);
        this.onImageLoad = this.handleImageLoad.bind(this);
        this.onSectionLoad = this.handleSectionLoad.bind(this);
        this.onSectionUnload = this.handleSectionUnload.bind(this);

        this.addMediaListener(this.motionQuery, this.onMotionChange);
        document.addEventListener('shopify:section:load', this.onSectionLoad, { signal: this.controller.signal });
        document.addEventListener('shopify:section:unload', this.onSectionUnload, { signal: this.controller.signal });

        this.setupParallax();
      }

      disconnectedCallback() {
        this.teardown();
      }

      teardown() {
        if (this.animationFrame) {
          window.cancelAnimationFrame(this.animationFrame);
        }

        this.animationFrame = null;

        if (this.motionQuery && this.onMotionChange) {
          this.removeMediaListener(this.motionQuery, this.onMotionChange);
        }

        if (this.controller) {
          this.controller.abort();
        }

        this.parallaxStates?.forEach((state) => {
          state.overlay.style.removeProperty('--giesto-overlay-translate-y');
          state.overlay.classList.remove('is-visible');
          delete state.overlay.dataset.giestoParallaxManaged;
        });

        this.parallaxStates = [];
        this.controller = null;
      }

      addMediaListener(query, listener) {
        if (query.addEventListener) {
          query.addEventListener('change', listener);
        } else {
          query.addListener(listener);
        }
      }

      removeMediaListener(query, listener) {
        if (query.removeEventListener) {
          query.removeEventListener('change', listener);
        } else {
          query.removeListener(listener);
        }
      }

      handleScroll() {
        this.refreshParallax(this.motionQuery?.matches);
      }

      handleMotionChange(event) {
        this.refreshParallax(event.matches);
      }

      handleImageLoad() {
        this.refreshParallax(this.motionQuery?.matches);
      }

      handleSectionLoad(event) {
        if (this.ownsSectionEvent(event) && this.isConnected) {
          this.connectedCallback();
        }
      }

      handleSectionUnload(event) {
        if (this.ownsSectionEvent(event)) {
          this.teardown();
        }
      }

      ownsSectionEvent(event) {
        const target = event.target;
        return target === this || Boolean(target?.contains?.(this));
      }

      setupParallax() {
        if (!this.hasAttribute('data-parallax')) return;

        this.parallaxStates = Array.from(this.querySelectorAll('.giesto-media-banner__overlay'))
          .map((overlay) => ({
            overlay,
            section: overlay.closest('.giesto-media-banner__media'),
            currentY: 0,
            targetY: 0,
          }))
          .filter((state) => state.section);

        if (!this.parallaxStates.length) return;

        this.parallaxStates.forEach((state) => {
          state.overlay.dataset.giestoParallaxManaged = 'true';
        });

        this.querySelectorAll('.giesto-media-banner__media img').forEach((image) => {
          image.addEventListener('load', this.onImageLoad, { signal: this.controller.signal });
          if (image.complete) this.handleImageLoad();
        });

        document.addEventListener('scroll', this.onScroll, {
          capture: true,
          passive: true,
          signal: this.controller.signal,
        });
        window.addEventListener('resize', this.onScroll, {
          passive: true,
          signal: this.controller.signal,
        });

        this.refreshParallax(this.motionQuery.matches);
      }

      refreshParallax(immediate = false) {
        if (!this.parallaxStates?.length) return;

        const shouldApplyImmediately = Boolean(immediate || this.motionQuery?.matches);

        if (shouldApplyImmediately) {
          if (this.animationFrame) {
            window.cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
          }

          this.applyParallax(true);
          return;
        }

        if (this.animationFrame) return;

        this.animationFrame = window.requestAnimationFrame(() => {
          this.animationFrame = null;
          this.applyParallax(false);
        });
      }

      applyParallax(immediate) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        let shouldContinue = false;

        this.parallaxStates.forEach((state) => {
          const section = state.section;
          const overlay = state.overlay;
          const sectionRect = section.getBoundingClientRect();
          const isRendered = section.getClientRects().length > 0 && sectionRect.height > 0;
          const isWithinBuffer = sectionRect.bottom >= -120 && sectionRect.top <= viewportHeight + 120;
          const logoHeight = overlay.getBoundingClientRect().height;

          if (!isRendered || !isWithinBuffer || !logoHeight) {
            state.currentY = 0;
            state.targetY = 0;
            overlay.style.setProperty('--giesto-overlay-translate-y', '0px');
            overlay.classList.remove('is-visible');
            return;
          }

          const progress = Math.max(
            0,
            Math.min(1, (viewportHeight - sectionRect.top + 120) / (viewportHeight + sectionRect.height + 240))
          );
          const easedProgress = progress * progress * (3 - 2 * progress);
          state.targetY = Math.max(sectionRect.height - logoHeight, 0) * easedProgress;
          overlay.classList.add('is-visible');

          if (immediate) {
            state.currentY = state.targetY;
          } else {
            state.currentY += (state.targetY - state.currentY) * 0.16;
            if (Math.abs(state.targetY - state.currentY) > 0.1) {
              shouldContinue = true;
            } else {
              state.currentY = state.targetY;
            }
          }

          overlay.style.setProperty('--giesto-overlay-translate-y', `${state.currentY.toFixed(2)}px`);
        });

        if (!immediate && shouldContinue) {
          this.refreshParallax(false);
        }
      }
    }

    customElements.define('giesto-media-banner', GiestoMediaBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-basic-footer"] && !Shopify.designMode) return;
  try {
    
  // Each footer column is a <details>. Below 750px it is a disclosure the
  // visitor opens; from 750px up every column is held open and its summary
  // leaves the tab order, so the footer reads as plain columns again.
  if (!window.GiestoStoreBasicFooterDisclosures) {
    window.GiestoStoreBasicFooterDisclosures = true;

    const footerDisclosureMedia = window.matchMedia('(min-width: 750px)');

    const syncFooterDisclosures = (root = document) => {
      root.querySelectorAll('[data-giesto-footer-disclosure]').forEach((disclosure) => {
        if (!(disclosure instanceof HTMLDetailsElement)) return;

        disclosure.open = footerDisclosureMedia.matches;

        const summary = disclosure.querySelector('summary');
        if (summary instanceof HTMLElement) {
          summary.tabIndex = footerDisclosureMedia.matches ? -1 : 0;
        }
      });
    };

    const syncAllFooterDisclosures = () => syncFooterDisclosures(document);

    footerDisclosureMedia.addEventListener('change', syncAllFooterDisclosures);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) syncFooterDisclosures(event.target);
    });

    window.GiestoStoreBasicFooterSync = syncAllFooterDisclosures;
  }

  window.GiestoStoreBasicFooterSync?.();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-collection"]) return;
  try {
    
  class GiestoStoreCollection extends HTMLElement {
    // Kept as a static so the identifier cannot collide with another section's
    // script block - Shopify concatenates them all into one file.
    static VIEW_STORAGE_KEY = 'giesto:collection-view';
    static viewState = null;
    static DRAWER_ID = 'filters-drawer';

    // How much of the chip straddling the right edge stays in view, and the
    // band around it that is close enough to leave the row untouched.
    static CHIP_PEEK = 0.3;
    static CHIP_PEEK_MIN = 0.22;
    static CHIP_PEEK_MAX = 0.4;
    // How far the gap and the chip padding may travel from their design values
    // to reach that share. Measured across 320-900px, the gap stays inside 5-13
    // on every phone width and only reaches the bound at 320.
    static CHIP_GAP_ROOM = 8;
    static CHIP_PAD_ROOM = 4;

    #controller = null;
    #drawerObserver = null;
    #observedDrawer = null;
    #relabelQueued = false;
    #descriptionSyncQueued = false;
    #chipPeekQueued = false;
    #descriptionFull = null;
    #viewValue = '4';

    connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.addEventListener('change', this.#onChange, { signal });
      this.addEventListener('click', this.#onClick, { signal });
      document.addEventListener('click', this.#onDocumentClick, { signal });
      document.addEventListener('keydown', this.#onKeydown, { signal });

      // theme-drawer.js fires this on the <theme-drawer> element and it bubbles,
      // same contract giesto-header.liquid listens on for the cart drawer.
      document.addEventListener('theme-drawer:open', this.#onDrawerOpen, { signal });
      document.addEventListener('theme-drawer:close', this.#onDrawerClose, { signal });

      // Shopify's standard search bus — StandardEvents.searchUpdate. Fires when
      // a facet is applied, which is also when the section is re-rendered.
      document.addEventListener('shopify:search:update', this.#queueRelabel, { signal });

      // Whether two lines is short enough to hide anything depends on the
      // column width, so the measurement is redone whenever that can change.
      window.addEventListener('resize', this.#queueDescriptionSync, { signal });
      window.addEventListener('resize', this.#queueChipPeek, { signal });
      window.addEventListener('resize', this.#positionView, { signal });
      matchMedia('(max-width: 1024px)').addEventListener('change', () => {
        this.#syncArketView(this.#viewValue);
        this.#positionView();
      }, { signal });
      window.addEventListener('scroll', this.#positionView, { signal, passive: true });
      this.addEventListener('close', this.#onViewClose, { signal, capture: true });
      this.#syncDescription();
      this.#queueChipPeek();

      // Chip widths are set by the shop's own face, so a row measured before it
      // arrives is measured against the fallback and lands on the wrong chip.
      document.fonts?.ready.then(this.#queueChipPeek);

      this.#restoreView();

      // If this element upgrades while the parser is still ahead of the drawer
      // markup, querySelector finds nothing — wait for the document instead.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.#queueRelabel, { once: true, signal });
      } else {
        this.#relabelDrawer();
        this.#observeDrawer();
      }
    }

    disconnectedCallback() {
      this.#closeView();
      this.#drawerObserver?.disconnect();
      this.#drawerObserver = null;
      this.#observedDrawer = null;
      this.#controller?.abort();
      this.#controller = null;
    }

    /* ---------- Collection description ---------- */

    #toggleDescription(button) {
      const description = button.closest('[data-gac-description]');
      if (!(description instanceof HTMLElement)) return;

      const expanded = description.dataset.expanded !== 'true';

      description.dataset.expanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));

      const label = button.querySelector('[data-gac-description-label]');
      const text = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (label && text) label.textContent = text;

      // Re-measures on the way back down; on the way up it just restores the
      // full text.
      this.#syncDescription();
    }

    /**
     * Shortens the description until the text AND the control fit in two lines,
     * so the control ends up immediately after the last word. CSS cannot do
     * this: a clamped box reports nothing about where its text stopped.
     */
    #syncDescription = () => {
      const description = this.querySelector('[data-gac-description]');
      if (!(description instanceof HTMLElement)) return;

      const body = description.querySelector('.gac__description-body');
      const text = description.querySelector('[data-gac-description-text]');
      if (!(body instanceof HTMLElement) || !(text instanceof HTMLElement)) return;

      // Read once, before anything has been cut away from it.
      if (this.#descriptionFull === null) this.#descriptionFull = text.textContent ?? '';
      const full = this.#descriptionFull;

      description.dataset.mode = 'js';

      if (description.dataset.expanded === 'true') {
        text.textContent = full;
        return;
      }

      const lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 22;
      const maxHeight = lineHeight * 2 + 1;

      // Measured with the control hidden: a description that fits on its own
      // needs no control, and one that only fits without it does need one.
      description.dataset.clamped = 'false';
      text.textContent = full;
      if (body.offsetHeight <= maxHeight) return;

      description.dataset.clamped = 'true';

      // Longest prefix that still leaves room for the control on line two.
      let low = 0;
      let high = full.length;
      let fits = 0;

      while (low <= high) {
        const middle = (low + high) >> 1;
        text.textContent = full.slice(0, middle);

        if (body.offsetHeight <= maxHeight) {
          fits = middle;
          low = middle + 1;
        } else {
          high = middle - 1;
        }
      }

      // Back off to a word boundary, then drop whatever punctuation the cut
      // left dangling, so the ellipsis does not follow a stray comma.
      let clipped = full.slice(0, fits);
      const lastSpace = clipped.lastIndexOf(' ');
      if (lastSpace > 0) clipped = clipped.slice(0, lastSpace);

      text.textContent = clipped.replace(/[\s.,;:!?-]+$/u, '');
    };

    #queueDescriptionSync = () => {
      if (this.#descriptionSyncQueued) return;
      this.#descriptionSyncQueued = true;

      requestAnimationFrame(() => {
        this.#descriptionSyncQueued = false;
        this.#syncDescription();
      });
    };

    /* ---------- Chip row peek ---------- */

    #queueChipPeek = () => {
      if (this.#chipPeekQueued) return;
      this.#chipPeekQueued = true;

      requestAnimationFrame(() => {
        this.#chipPeekQueued = false;
        this.#tuneChipPeek();
      });
    };

    /**
     * Below the wrap breakpoint a chip row is a horizontal scroller, and where
     * it happens to end flush with the screen edge it reads as the whole list —
     * nothing tells a shopper the rest of the categories are one swipe away.
     * Whether that happens is down to the viewport width against the sum of the
     * chip widths, so it cannot be pinned in CSS at every resolution.
     *
     * This leaves the chip that crosses the edge about a third in view. The
     * shift rides on the gaps and the chips' own side padding rather than on
     * the row's leading padding, so the first chip stays on the same gutter as
     * the title above it and the row reads as slightly roomier rather than
     * visibly gappy — splitting it across two dimensions halves how far either
     * has to move. It only runs on a scroller that is not already cut at a
     * readable share, so most widths are left exactly as designed.
     */
    #tuneChipPeek = () => {
      const { CHIP_PEEK, CHIP_PEEK_MIN, CHIP_PEEK_MAX, CHIP_GAP_ROOM, CHIP_PAD_ROOM } = GiestoStoreCollection;

      for (const list of this.querySelectorAll('.gac__chips-list')) {
        // Only the first view is tuned. A shopper who has already swiped can
        // see the rest of the row for themselves, and re-spacing it under their
        // finger — which a morph after a filter would do — is worse than an
        // edge that happens to fall flush.
        if (list.scrollLeft > 1) continue;

        // Measure against the design values, never against a previous tuning.
        list.style.removeProperty('--gac-chips-gap');
        list.style.removeProperty('--gac-chip-pad');

        const styles = getComputedStyle(list);
        // Wrapped rows hold every chip already: there is nothing behind an edge.
        if (styles.flexWrap === 'wrap') continue;

        const items = [...list.children];
        if (items.length < 2) continue;

        // The right edge of the row as it first appears, in content
        // coordinates — the shopper has not scrolled yet.
        const edge = list.clientWidth;
        const listLeft = list.getBoundingClientRect().left;
        const bounds = items.map((item) => {
          const rect = item.getBoundingClientRect();
          const start = rect.left - listLeft + list.scrollLeft;
          return { start, end: start + rect.width, width: rect.width };
        });

        // Every chip fits: there is nothing to swipe to, so nothing to hint at.
        if (bounds[bounds.length - 1].end <= edge + 1) continue;

        const index = bounds.findIndex((item) => item.end > edge);
        // A first chip wider than the screen has no gap in front of it to move.
        if (index < 1) continue;

        const chip = bounds[index];
        const visible = (edge - chip.start) / chip.width;
        if (visible >= CHIP_PEEK_MIN && visible <= CHIP_PEEK_MAX) continue;

        const pill = list.querySelector('.gac__chip');
        if (!pill) continue;

        // Everything ahead of the chip carries an equal share of the shift:
        // each of the `index` gaps one step, each of the `index` chips before it
        // two half-steps of side padding. That is 2 * index steps in all.
        const gap = parseFloat(styles.columnGap) || 0;
        const pad = parseFloat(getComputedStyle(pill).paddingLeft) || 0;
        const step = (edge - chip.width * CHIP_PEEK - chip.start) / (index * 2);

        // Bounded, so a row that would need a sparse gap to reach the third
        // comes out cut a little short of it instead.
        const tunedGap = Math.min(Math.max(gap + step, 4), gap + CHIP_GAP_ROOM);
        const tunedPad = Math.min(Math.max(pad + step / 2, 8), pad + CHIP_PAD_ROOM);
        if (Math.abs(tunedGap - gap) < 0.5 && Math.abs(tunedPad - pad) < 0.5) continue;

        list.style.setProperty('--gac-chips-gap', `${tunedGap.toFixed(2)}px`);
        list.style.setProperty('--gac-chip-pad', `${tunedPad.toFixed(2)}px`);
      }
    };

    /* ---------- Filter drawer copy ---------- */

    #getDrawer() {
      return (
        this.querySelector(`#${GiestoStoreCollection.DRAWER_ID}`) ??
        document.getElementById(GiestoStoreCollection.DRAWER_ID)
      );
    }

    // Rewrites only text nodes. The count badge, its visually-hidden sibling and
    // every other node in the drawer are left exactly as the theme rendered them.
    // Writes happen only when the text actually differs, so re-entering through
    // the MutationObserver settles after one pass instead of looping.
    #relabelDrawer() {
      const drawer = this.#getDrawer();
      if (!drawer) return;

      const title = this.dataset.filterDrawerTitle;
      const heading = drawer.querySelector('.theme-drawer__title');
      if (title && heading) {
        for (const node of heading.childNodes) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          if (!node.nodeValue?.trim()) continue;
          // Trailing space preserved: it is the only gap between the heading
          // and the filter-count badge that follows it.
          if (node.nodeValue.trim() !== title) node.nodeValue = `${title} `;
          break;
        }
      }

      const applyLabel = this.dataset.filterApplyLabel;
      const applyButton = drawer.querySelector('.facets__see-results');
      if (applyLabel && applyButton) {
        const themeLabel = applyButton.textContent?.trim();
        if (themeLabel && themeLabel !== applyLabel) {
          // The theme's label carries the result count, which is the whole point
          // of that button. Keep it in the accessible name, prefixed with the
          // visible word so the name still contains the visible label.
          applyButton.setAttribute('aria-label', `${applyLabel}, ${themeLabel}`);
          applyButton.textContent = applyLabel;
        }
      }
    }

    // The drawer node survives a morph (data-skip-node-update keeps the element
    // itself, but morph still recurses into its children and restores the
    // theme's text), so re-binding is only needed if the node identity changes.
    #observeDrawer() {
      const drawer = this.#getDrawer();
      if (!drawer) return;
      if (this.#observedDrawer === drawer && this.#drawerObserver) return;

      this.#drawerObserver?.disconnect();
      this.#observedDrawer = drawer;
      this.#drawerObserver = new MutationObserver(this.#queueRelabel);
      this.#drawerObserver.observe(drawer, { childList: true, characterData: true, subtree: true });
    }

    // A morph touches many nodes at once; coalesce them into one relabel.
    #queueRelabel = () => {
      if (this.#relabelQueued) return;
      this.#relabelQueued = true;
      requestAnimationFrame(() => {
        this.#relabelQueued = false;
        this.#relabelDrawer();
        this.#observeDrawer();
        this.#syncArketView(this.#viewValue);
        // A morph can add, drop or re-label chips, which moves the edge.
        this.#tuneChipPeek();
      });
    };

    #onDrawerOpen = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      this.#setDrawerTriggerState(target.id, true);
      if (target.id === GiestoStoreCollection.DRAWER_ID) {
        target.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        const scroller = target.querySelector('.facets-drawer__filters');
        if (scroller) scroller.scrollTop = 0;
        this.#relabelDrawer();
        this.#observeDrawer();
      }
    };

    #onDrawerClose = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      this.#setDrawerTriggerState(target.id, false);
    };

    #setDrawerTriggerState(drawerId, open) {
      if (!drawerId) return;
      const trigger = this.querySelector(`[data-gac-drawer-trigger="${CSS.escape(drawerId)}"]`);
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    };

    // Declarative `on:click` actions intentionally only upgrade custom elements
    // ending in `-component`. A <theme-drawer> may therefore still be a plain
    // element on a slow Theme Editor preview when the shopper clicks it. Keep
    // this recovery local to the ARKET collection controls instead of changing
    // the theme-wide action dispatcher.
    #requestDrawerAction(drawerId, action) {
      const drawer = this.querySelector(`#${CSS.escape(drawerId)}`) ?? document.getElementById(drawerId);
      if (!(drawer instanceof HTMLElement)) return;

      const invoke = () => {
        if (!drawer.isConnected) return false;

        try {
          customElements.upgrade(drawer);
        } catch {
          // A not-yet-defined custom element is retried below.
        }

        const method = drawer[action];
        if (typeof method !== 'function') return false;
        method.call(drawer);
        return true;
      };

      if (invoke()) return;

      if (action === 'close') {
        // If the module is still loading, do not leave a visible native dialog
        // trapping the preview. The upgraded drawer will see the cleared state
        // once it finishes loading.
        const panel = drawer.querySelector('dialog');
        if (panel instanceof HTMLDialogElement && panel.open) panel.close();
        drawer.removeAttribute('open');
        this.#setDrawerTriggerState(drawerId, false);
      }

      customElements.whenDefined('theme-drawer').then(() => {
        invoke();
      });
    };

    // ARKET retains the choice during filtering, but starts a new collection
    // (or explicit reload) in the default 4/2-column view. Shopify sorting uses
    // full navigation, so retain that same-collection state through the request.
    #restoreView() {
      let state = GiestoStoreCollection.viewState;
      if (!state && performance.getEntriesByType('navigation')[0]?.type !== 'reload') {
        try { state = JSON.parse(sessionStorage.getItem(GiestoStoreCollection.VIEW_STORAGE_KEY)); } catch {}
      }
      const value = state?.path === location.pathname ? state.value : '4';
      this.#syncArketView(value);
    }

    #closeView() {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (panel?.open) panel.close();
      this.querySelector('[data-gac-view-trigger]')?.setAttribute('aria-expanded', 'false');
    }

    #onViewClose = event => {
      if (event.target.matches('[data-gac-view-panel]')) this.#closeView();
    };

    #positionView = () => {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (!panel?.open) return;
      const trigger = this.querySelector('[data-gac-view-trigger]');
      if (!trigger?.getClientRects().length) { this.#closeView(); return; }
      const anchor = trigger.getBoundingClientRect();
      const box = panel.getBoundingClientRect();
      // The reference panel aligns 16px from the viewport edge.
      panel.style.left = Math.max(16, innerWidth - box.width - 16) + 'px';
      panel.style.top = Math.max(16, Math.min(anchor.bottom + 8, innerHeight - box.height - 16)) + 'px';
    };

    #syncArketView(value) {
      const compact = this.hasAttribute('data-gac-story-enabled') && matchMedia('(max-width: 1024px)').matches;
      if (compact && value === '3') value = '4';
      this.#viewValue = value === 'stories' && this.hasAttribute('data-gac-story-enabled') ? 'stories' : value === '3' ? '3' : '4';
      document.body.dataset.gaView = this.#viewValue;
      this.dataset.gacView = this.#viewValue;
      const stories = this.querySelector('giesto-collection-stories');
      if (stories) {
        stories.hidden = this.#viewValue !== 'stories';
        if (!stories.hidden) stories.activate?.();
      }
      GiestoStoreCollection.viewState = {path: location.pathname, value: this.#viewValue};
      try { sessionStorage.setItem(GiestoStoreCollection.VIEW_STORAGE_KEY, JSON.stringify(GiestoStoreCollection.viewState)); } catch {}
      for (const option of this.querySelectorAll('[data-gac-view-option]')) {
        option.disabled = compact && option.value === '3';
        option.checked = option.value === this.#viewValue;
      }
      const occupied = new Set();
      let cursor = 0;
      // A 2×2 feature only remains in the three-column view if it fits at
      // the next product position, matching the reference's packing rule.
      for (const cell of this.querySelectorAll('.gac__cell')) {
        while (occupied.has(cursor)) cursor++;
        const slots = [cursor, cursor + 1, cursor + 3, cursor + 4];
        const big = cell.classList.contains('gac__cell--feature') && cursor % 3 < 2 && slots.every(slot => !occupied.has(slot));
        cell.classList.toggle('ga-alt-feature', big);
        for (const slot of big ? slots : [cursor]) occupied.add(slot);
        cursor++;
      }
    }

    #onChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('[data-gac-sort], [data-gac-sort-option]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', /** @type {HTMLSelectElement} */ (target).value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
        return;
      }

      if (target.matches('[data-gac-view-option]')) {
        this.#closeView();
        this.#syncArketView(/** @type {HTMLInputElement} */ (target).value);
      }
    };

    /**
     * Mirrors a chip click onto the product type checkboxes right away. The
     * group is single-select, so a chip clears every other box in it — the same
     * rule facets.js applies when the box itself is the control. The re-render
     * morphs them to the server's state a moment later; this only covers the
     * gap, so a shopper who opens the drawer while the request is still in
     * flight never sees the box disagree with the chip.
     * @param {HTMLAnchorElement} chip
     */
    #syncTypeInputs(chip) {
      const param = this.dataset.gacTypeFilterParam;
      if (!param) return;

      const value = chip.dataset.gacTypeValue;
      for (const input of this.querySelectorAll('input[type="checkbox"]')) {
        if (!(input instanceof HTMLInputElement) || input.name !== param) continue;

        // The "view all" chip carries no value: it clears the whole group.
        // Every other chip keeps only its own box — an active chip is the
        // removal link, so clicking it clears that one too and means "any".
        input.checked = Boolean(value) && input.value === value && !chip.classList.contains('is-active');
      }
    }

    #onClick = (event) => {
      // Element, not HTMLElement — clicks landing on an inline <svg> or <path>
      // are SVGElement, and an HTMLElement check would swallow them.
      const target = event.target;
      if (!(target instanceof Element)) return;

      const descriptionToggle = target.closest('[data-gac-description-toggle]');
      if (descriptionToggle instanceof HTMLButtonElement && this.contains(descriptionToggle)) {
        this.#toggleDescription(descriptionToggle);
        return;
      }

      const tagChip = target.closest('[data-gac-tag-chip]');
      if (tagChip instanceof HTMLAnchorElement && this.contains(tagChip)) {
        const tagFilterParam = this.dataset.gacTagFilterParam;

        // Without Shopify's Product tag storefront filter, the rendered link
        // remains a complete legacy-tag URL. With it enabled, keep the modern
        // facet flow so sort and every other selected filter survive the
        // category switch, while the tag itself stays mutually exclusive.
        if (!tagFilterParam) return;

        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.delete(tagFilterParam);

        const tagValue = tagChip.dataset.gacTagValue;
        if (tagValue) url.searchParams.set(tagFilterParam, tagValue);
        url.searchParams.delete('page');

        const facetsForm = this.querySelector('facets-form-component');
        if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
          facetsForm.updateFiltersByURL(url.toString());
        } else {
          window.location.assign(url.toString());
        }
        return;
      }

      // Product type chips. The group is single-select, so the href is the
      // group's removal URL with this one type appended — exactly the URL the
      // matching checkbox in the filter drawer now submits, because clearing
      // its siblings is what facets.js does there. Both controls resolve to one
      // URL state and neither can drift from the other. Applying it through the
      // facets form re-renders the section, which is also what repaints the
      // drawer's checkboxes and the active chip.
      const typeChip = target.closest('[data-gac-type-chip]');
      if (typeChip instanceof HTMLAnchorElement && this.contains(typeChip)) {
        const facetsForm = this.querySelector('facets-form-component');

        // Filters hidden, or facets.js not loaded yet: let the link navigate.
        // The same URL filters server-side, just with a full page load.
        if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') return;

        event.preventDefault();
        this.#syncTypeInputs(typeChip);

        // Pagination belongs to the result set being left behind: carried over,
        // a switch to a category with fewer pages lands on an empty grid.
        const typeUrl = new URL(typeChip.href);
        typeUrl.searchParams.delete('page');
        facetsForm.updateFiltersByURL(typeUrl.toString());
        return;
      }

      const drawerTrigger = target.closest('[data-gac-drawer-open]');
      if (drawerTrigger instanceof HTMLElement && this.contains(drawerTrigger)) {
        const drawerId = drawerTrigger.dataset.gacDrawerOpen;
        if (drawerId) this.#requestDrawerAction(drawerId, 'open');
        return;
      }

      const drawerClose = target.closest('[data-gac-drawer-close]');
      if (drawerClose instanceof HTMLElement && this.contains(drawerClose)) {
        const drawerId = drawerClose.dataset.gacDrawerClose;
        if (drawerId) this.#requestDrawerAction(drawerId, 'close');
        return;
      }

      // Clicking the already-selected radio does not emit change.
      if (target.matches('[data-gac-view-option]')) this.#closeView();

      const viewTrigger = target.closest('[data-gac-view-trigger]');
      if (viewTrigger) {
        const panel = this.querySelector('[data-gac-view-panel]');
        if (!(panel instanceof HTMLDialogElement)) return;
        if (panel.open) this.#closeView();
        else {
          panel.showModal();
          this.querySelector('giesto-collection-stories')?.prefetch?.();
          viewTrigger.setAttribute('aria-expanded', 'true');
          this.#positionView();
        }
        return;
      }

      // The gallery arrows are handled by assets/giesto-store-card.js, delegated
      // from the document, so every section that renders the card gets them.
      // This element used to own that logic, which left the arrows dead on any
      // page without it — the sale page, for one.
    };



    #onDocumentClick = (event) => {
      const panel = this.querySelector('[data-gac-view-panel]');
      if (!panel?.open || event.target !== panel) return;
      const box = panel.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.#closeView();
    };

    #onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.querySelector('[data-gac-view-panel]')?.open) return;
      event.preventDefault();
      this.#closeView();
    };

  }

  if (!customElements.get('giesto-store-collection')) {
    customElements.define('giesto-store-collection', GiestoStoreCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-discovery"] && !Shopify.designMode) return;
  try {
    
  /**
   * Reveals the cards held back below the desktop breakpoint.
   *
   * Delegated from the document so it survives a section re-render in the theme
   * editor without needing to re-bind, and so one listener covers every instance
   * of the section on the page.
   */
  (() => {
    if (window.GiestoStoreDiscoveryMore) return;
    window.GiestoStoreDiscoveryMore = true;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-gs-discovery-more]');
      if (!(button instanceof HTMLButtonElement)) return;

      const section = button.closest('[data-gs-discovery]');
      if (!(section instanceof HTMLElement)) return;

      const expanded = section.dataset.expanded !== 'true';

      section.dataset.expanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));

      const label = button.querySelector('[data-gs-discovery-more-label]');
      const text = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (label && text) label.textContent = text;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-store-header')) {
    class GiestoStoreHeader extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.megaTriggers = Array.from(this.querySelectorAll('[data-gah-mega-trigger]'));
        this.megaPanels = Array.from(this.querySelectorAll('[data-gah-mega-panel]'));
        this.drawer = this.querySelector('[data-gah-drawer]');
        this.drawerTrigger = this.querySelector('[data-gah-drawer-open]');
        this.activeMega = null;

        this.onMegaTrigger = this.onMegaTrigger.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onDrawerOpen = this.onDrawerOpen.bind(this);
        this.onDrawerCloseClick = this.onDrawerCloseClick.bind(this);
        this.onDrawerClick = this.onDrawerClick.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        this.onPageHide = this.onPageHide.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onDesignSelect = this.onDesignSelect.bind(this);
        this.onDesignDeselect = this.onDesignDeselect.bind(this);

        /* A theme-editor remount or a bfcache restore can preserve stale state. */
        this.closeMega();
        this.closeDrawer();

        this.megaTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onMegaTrigger, { signal });
        });

        this.querySelectorAll('[data-gah-drawer-open]').forEach((trigger) => {
          trigger.addEventListener('click', this.onDrawerOpen, { signal });
        });

        this.querySelectorAll('[data-gah-drawer-close]').forEach((trigger) => {
          trigger.addEventListener('click', this.onDrawerCloseClick, { signal });
        });

        if (this.drawer) {
          this.drawer.addEventListener('click', this.onDrawerClick, { signal });
          this.drawer.addEventListener('close', this.onDrawerClose, { signal });
        }

        this.addEventListener('focusout', this.onFocusOut, { signal });
        document.addEventListener('pointerdown', this.onPointerDown, { signal });
        document.addEventListener('keydown', this.onKeydown, { signal });
        window.addEventListener('pagehide', this.onPageHide, { signal });
        this.desktopMedia.addEventListener('change', this.onBreakpointChange, { signal });

        this.scrollFrame = 0;
        this.condenseLocked = false;
        this.removeAttribute('data-gah-condensed');

        if (this.hasAttribute('data-gah-condense-on-scroll')) {
          this.pageWrapper = document.querySelector('.page-wrapper');
          this.announcement = this.querySelector('.giesto-store-header__announcement');

          /* Both containers are listened to rather than detected: which one
             actually scrolls flips at the 990px breakpoint, and a resize can
             swap them under us. Two passive listeners cost nothing. */
          window.addEventListener('scroll', this.onScroll, { passive: true, signal });
          this.pageWrapper?.addEventListener('scroll', this.onScroll, { passive: true, signal });

          if (window.Shopify?.designMode) {
            document.addEventListener('shopify:section:select', this.onDesignSelect, { signal });
            document.addEventListener('shopify:section:deselect', this.onDesignDeselect, { signal });
          }

          /* A reload restores scroll position before this runs. */
          this.syncCondensed();
        }
      }

      disconnectedCallback() {
        this.controller?.abort();

        /* Not an event listener, so abort() does not reach it. */
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
      }

      /* ---- Condense on scroll --------------------------------------------- */
      scrollOffset() {
        /* The scroll container differs by viewport: assets/base.css gives
           `.page-wrapper` `height: 100dvh; overflow-y: auto` at >= 990px, so
           desktop scrolls that element while mobile scrolls the document.
           Reading both and taking the larger avoids detecting which is live. */
        const wrapper = this.pageWrapper?.scrollTop || 0;
        const doc = window.scrollY || document.documentElement.scrollTop || 0;
        return Math.max(wrapper, doc);
      }

      onScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.syncCondensed();
        });
      }

      syncCondensed() {
        if (this.condenseLocked) return;

        const offset = this.scrollOffset();
        const condensed = this.hasAttribute('data-gah-condensed');

        /* Collapsing takes the announcement's height out of the content above
           the fold, and the browser's scroll anchoring compensates by pulling
           scrollTop down by that same amount. Measured at 390px: collapsing at
           scrollTop 50 left it at 13, which fell under a naive restore
           threshold and flipped the state straight back — 12 transitions in
           1.5s.

           So the two thresholds have to sit further apart than the row is
           tall. The height is read while the row is still expanded (only ever
           true near the top of the page, so this is not a per-frame layout
           read once condensed) and 64px of slack is added on top, which keeps
           it stable even for an announcement long enough to wrap. */
        if (!condensed && this.announcement) {
          this.announcementHeight = this.announcement.offsetHeight;
        }

        const restoreAbove = 8;
        const collapseAbove = restoreAbove + (this.announcementHeight || 44) + 64;

        if (!condensed && offset > collapseAbove) this.toggleAttribute('data-gah-condensed', true);
        else if (condensed && offset < restoreAbove) this.toggleAttribute('data-gah-condensed', false);
      }

      /* The merchant edits the announcement text in the sidebar; hiding the row
         because the preview happens to be scrolled would leave them editing
         something they cannot see. Pin it open while the section is selected. */
      onDesignSelect(event) {
        if (!(event.target instanceof Node) || !event.target.contains(this)) return;
        this.condenseLocked = true;
        this.removeAttribute('data-gah-condensed');
      }

      onDesignDeselect(event) {
        if (!(event.target instanceof Node) || !event.target.contains(this)) return;
        this.condenseLocked = false;
        this.syncCondensed();
      }

      isDesktop() {
        return Boolean(this.desktopMedia?.matches);
      }

      /* ---- Mega menu ------------------------------------------------------ */
      openMega(key) {
        this.megaPanels?.forEach((panel) => {
          const active = panel.dataset.gahMegaPanel === key;
          panel.toggleAttribute('data-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.megaTriggers?.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', trigger.dataset.gahMegaTrigger === key ? 'true' : 'false');
        });

        this.activeMega = key;
        this.setAttribute('data-mega-open', '');
      }

      closeMega() {
        this.megaPanels?.forEach((panel) => {
          panel.removeAttribute('data-active');
          panel.setAttribute('aria-hidden', 'true');
        });

        this.megaTriggers?.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        this.activeMega = null;
        this.removeAttribute('data-mega-open');
      }

      onMegaTrigger(event) {
        if (!this.isDesktop()) return;

        const key = event.currentTarget.dataset.gahMegaTrigger;
        if (!key) return;

        if (this.activeMega === key) {
          this.closeMega();
        } else {
          this.openMega(key);
        }
      }

      isInsideMega(node) {
        if (!(node instanceof Node)) return false;
        const inPanel = this.megaPanels?.some((panel) => panel.contains(node));
        const inTrigger = this.megaTriggers?.some((trigger) => trigger.contains(node));
        return Boolean(inPanel || inTrigger);
      }

      onPointerDown(event) {
        if (!this.activeMega) return;
        if (this.isInsideMega(event.target)) return;
        this.closeMega();
      }

      onFocusOut(event) {
        if (!this.activeMega) return;
        const next = event.relatedTarget;
        if (next instanceof Node && this.contains(next)) return;
        this.closeMega();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.activeMega) return;

        const active = this.megaTriggers?.find((trigger) => trigger.dataset.gahMegaTrigger === this.activeMega);
        this.closeMega();
        active?.focus();
      }

      onBreakpointChange() {
        if (this.isDesktop()) {
          this.closeDrawer();
        } else {
          this.closeMega();
        }
      }

      /* ---- Mobile drawer -------------------------------------------------- */
      onDrawerOpen() {
        if (!this.drawer) return;

        this.closeMega();

        if (typeof this.drawer.showModal === 'function') {
          if (!this.drawer.open) this.drawer.showModal();
        } else {
          this.drawer.setAttribute('open', '');
        }

        this.drawerTrigger?.setAttribute('aria-expanded', 'true');
        this.drawer.querySelector('[data-gah-drawer-close]')?.focus();
      }

      closeDrawer() {
        if (!this.drawer) return;

        if (this.drawer.open && typeof this.drawer.close === 'function') {
          this.drawer.close();
        } else {
          this.drawer.removeAttribute('open');
        }

        this.drawerTrigger?.setAttribute('aria-expanded', 'false');
      }

      onDrawerCloseClick() {
        this.closeDrawer();
      }

      onDrawerClick(event) {
        /* The dialog fills the viewport; the panel does not. Clicking the
           uncovered area means the click landed on the backdrop. */
        if (event.target === this.drawer) this.closeDrawer();
      }

      onDrawerClose() {
        this.drawerTrigger?.setAttribute('aria-expanded', 'false');
      }

      onPageHide() {
        this.closeMega();
        this.closeDrawer();
      }
    }

    customElements.define('giesto-store-header', GiestoStoreHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-product"]) return;
  try {
    
  class GiestoStoreProduct extends HTMLElement {
    #controller = null;
    #gallery = null;
    #variants = [];
    #selected = [];
    #hasOptions = false;
    #syncedColour = undefined;

    connectedCallback() {
      // The theme editor re-inserts a live section without minting a fresh
      // element, so connect must be safe to run twice in a row.
      this.disconnectedCallback();

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.#variants = this.#readVariants();
      this.#selected = this.#readSelection();
      this.#hasOptions = this.querySelectorAll('[data-gap-option]').length > 0;
      this.#gallery = this.querySelector('[data-gap-gallery]');

      this.addEventListener('click', this.#onClick, { signal });
      this.addEventListener('click', this.#guardSize, { signal, capture: true });
      this.addEventListener('submit', this.#guardSize, { signal, capture: true });
      this.addEventListener('theme-drawer:open', this.#onAccordionDrawerOpen, { signal });
      this.addEventListener('theme-drawer:close', this.#onAccordionDrawerClose, { signal });
      this.#gallery?.addEventListener('scroll', this.#onGalleryScroll, { signal, passive: true });

      this.#setIndex(0);
      this.#render();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#gallery = null;
    }

    get #isComingSoon() {
      return this.dataset.comingSoon === 'true';
    }

    #readVariants() {
      const node = this.querySelector('[data-gap-variants]');
      if (!node?.textContent) return [];

      try {
        const parsed = JSON.parse(node.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        // A malformed payload must not take the buy block down with it — the
        // server-rendered variant id in the hidden input still adds to cart.
        return [];
      }
    }

    /**
     * Reads the server-rendered selection into a value-per-option-position
     * array. It starts from the rendered variant's own options so positions
     * that render no buttons still hold a value, then lets the marked buttons
     * win — they are the ones the shopper can actually move.
     */
    #readSelection() {
      let selection = [];

      try {
        const parsed = JSON.parse(this.dataset.selectedOptions ?? '[]');
        if (Array.isArray(parsed)) selection = parsed.slice();
      } catch {
        /* fall back to whatever the buttons report */
      }

      for (const button of this.querySelectorAll('[data-gap-option][data-selected="true"]')) {
        const position = Number(button.dataset.optionPosition);
        if (!Number.isInteger(position) || position < 0) continue;

        selection[position] = button.dataset.optionValue ?? null;
      }

      return selection;
    }

    #guardSize = (event) => {
      if (!this.#hasOptions || this.#matchVariant() || this.#isComingSoon) return;
      if (event.type === 'click' && !event.target.closest('[ref="addToCartButton"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const sizes = this.querySelector('.gap__option');
      sizes?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizes?.classList.add('gap__option--required');
      sizes?.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
    };

    #onClick = (event) => {
      // Element, not HTMLElement — a click landing on an inline <svg> child is
      // an SVGElement and an HTMLElement check would swallow it.
      const target = event.target;
      if (!(target instanceof Element)) return;

      const accordionTrigger = target.closest('[data-gap-accordion-trigger]');
      if (accordionTrigger instanceof HTMLButtonElement) {
        this.#openAccordionDrawer(accordionTrigger);
        return;
      }

      const dot = target.closest('[data-gap-dot]');
      if (dot) {
        this.#scrollToFrame(Number(dot.getAttribute('data-gap-dot')));
        return;
      }

      // The thumbnails are real in-page anchors so the rail still works with
      // JavaScript off. Left to the browser, though, following that hash calls
      // scrollIntoView on the frame, which scrolls EVERY scrollable ancestor -
      // the document included - so the page jumped down on every thumbnail
      // click. Handling it here scrolls only the media scroller.
      const thumb = target.closest('[data-gap-thumb]');
      if (thumb) {
        event.preventDefault();
        this.#showFrame(Number(thumb.getAttribute('data-gap-thumb')));
        return;
      }

      const option = target.closest('[data-gap-option]');
      if (!option || option.disabled) return;

      const position = Number(option.dataset.optionPosition);
      if (!Number.isInteger(position) || position < 0) return;

      this.#selected[position] = option.dataset.optionValue ?? null;
      this.querySelectorAll('.gap__option--required').forEach(row => row.classList.remove('gap__option--required'));
      this.#render();

      // Colours live in a disclosure; collapse it once a choice lands.
      option.closest('details[data-gap-colour]')?.removeAttribute('open');
    };

    /**
     * Opens a product-information drawer without relying on the declarative
     * action handler. Sections can arrive before the `theme-drawer` module is
     * upgraded in the Theme Editor, so this direct path retries once the
     * custom element definition is available.
     */
    #openAccordionDrawer(trigger) {
      const drawerId = trigger.getAttribute('aria-controls');
      if (!drawerId) return;

      const drawer = document.getElementById(drawerId);
      if (!(drawer instanceof HTMLElement)) return;

      trigger.focus({ preventScroll: true });

      const tryOpen = () => {
        customElements.upgrade(drawer);
        if (typeof drawer.open !== 'function') return false;

        drawer.open();
        return true;
      };

      if (tryOpen()) return;

      customElements.whenDefined('theme-drawer').then(() => {
        if (!document.contains(drawer)) return;
        tryOpen();
      });
    }

    #onAccordionDrawerOpen = (event) => {
      this.#syncAccordionTrigger(event.target, true);
    };

    #onAccordionDrawerClose = (event) => {
      this.#syncAccordionTrigger(event.target, false);
    };

    #syncAccordionTrigger(drawer, expanded) {
      if (!(drawer instanceof HTMLElement) || !drawer.matches('theme-drawer[data-gap-accordion-drawer]')) {
        return;
      }

      const trigger = this.querySelector(
        `[data-gap-accordion-trigger][aria-controls="${drawer.id}"]`
      );
      trigger?.setAttribute('aria-expanded', String(expanded));
    }

    #render() {
      if (!this.#hasOptions || this.#variants.length === 0) return;

      const variant = this.#matchVariant();
      this.#renderOptionStates();
      this.#renderColour();
      this.#renderPrice(variant);
      this.#renderForm(variant);
      this.#syncMedia(variant);
      // The sticky bar reads availability straight off this payload, so a
      // coming-soon product reports its variant as unavailable there too.
      const payloadVariant = this.#isComingSoon && variant ? { ...variant, available: false } : variant;

      this.dispatchEvent(
        new CustomEvent('giesto:variant-change', {
          bubbles: true,
          detail: {
            productId: this.dataset.productId,
            variant: payloadVariant,
            selectedOptions: [...this.#selected],
          },
        })
      );
    }

    #matchVariant() {
      return (
        this.#variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.every((value, position) => this.#selected[position] === value)
        ) ?? null
      );
    }

    /**
     * A value is offerable when some available variant carries it alongside
     * everything else the shopper has already picked.
     */
    #isValueAvailable(position, value) {
      return this.#variants.some(
        (variant) =>
          variant.available &&
          Array.isArray(variant.options) &&
          variant.options[position] === value &&
          variant.options.every(
            (option, index) => index === position || this.#selected[index] == null || this.#selected[index] === option
          )
      );
    }

    #renderOptionStates() {
      for (const button of this.querySelectorAll('[data-gap-option]')) {
        const position = Number(button.dataset.optionPosition);
        if (!Number.isInteger(position) || position < 0) continue;

        const value = button.dataset.optionValue ?? '';
        const selected = this.#selected[position] === value;
        const available = this.#isValueAvailable(position, value);

        button.dataset.selected = String(selected);
        button.dataset.available = String(available);
        button.setAttribute('aria-checked', String(selected));

        // Struck-through values are not clickable, but the current selection
        // stays operable so a shopper can never be trapped on a dead cell.
        button.disabled = !available && !selected;
      }
    }

    #renderColour() {
      const position = Number(this.dataset.colourPosition);
      if (!Number.isInteger(position) || position < 0) return;

      const name = this.#selected[position];
      const label = this.querySelector('[data-gap-colour-name]');
      if (label && name) label.textContent = name;

      const swatch = this.querySelector('[data-gap-colour-swatch]');
      const source = this.querySelector(
        `[data-gap-option][data-option-position="${position}"][data-selected="true"]`
      );
      if (swatch instanceof HTMLElement && source instanceof HTMLElement) {
        swatch.style.background = source.dataset.swatchBackground || 'var(--gs-grey)';
      }
    }

    #renderPrice(variant) {
      if (!variant) return;

      const value = this.querySelector('[data-gap-price-value]');
      const compare = this.querySelector('[data-gap-price-compare]');
      const onSale = Boolean(variant.compare_at);

      // innerHTML, not textContent: the payload is the `money` filter's own
      // output, so any currency-app wrapper the shop's money_format adds
      // survives a variant switch. See the capture note in the Liquid above.
      if (value) {
        value.innerHTML = variant.price ?? '';
        value.classList.toggle('gap__price-value--sale', onSale);
      }

      if (compare) {
        compare.innerHTML = onSale ? variant.compare_at : '';
        compare.toggleAttribute('hidden', !onSale);
      }
    }

    /**
     * product-form-component reads input[name="id"] out of the DOM at submit
     * time, so writing the value here is all the wiring add-to-cart needs.
     */
    #renderForm(variant) {
      const input = this.querySelector('input[name="id"]');

      // A coming-soon product never opens for sale, so no resolved variant may
      // switch the button back on - the server rendered it off on purpose.
      const available = !this.#isComingSoon && (!variant || Boolean(variant.available));

      if (input instanceof HTMLInputElement) {
        input.value = variant ? String(variant.id) : '';
        input.disabled = !variant?.available || this.#isComingSoon;
      }

      const container = this.querySelector('add-to-cart-component');
      const button = this.querySelector('[ref="addToCartButton"]');

      if (container && typeof container.disable === 'function' && typeof container.enable === 'function') {
        if (available) {
          container.enable();
        } else {
          container.disable();
        }
      } else if (button instanceof HTMLButtonElement) {
        button.disabled = !available;
      }

      if (!button) return;

      // add-to-cart-button prints its label as a bare text node between the
      // icon and the burst markup, so swap the node rather than the innerHTML.
      const label = available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      const textNode = Array.from(button.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent?.trim()
      );
      if (textNode && label) textNode.textContent = label;
    }

    #syncMedia(variant) {
      // A colour gallery spreads one colour's photos across its sizes, so a
      // variant's media is not "its" photo: a size change must leave the
      // carousel where it is. assets/giesto-colour-gallery.js owns the
      // position there, and resets it only when the colour changes.
      if (this.dataset.colourGallery !== undefined) return;

      // A multi-colour product may carry the same per-size links without
      // qualifying for the colour gallery, so only a colour change may move
      // the carousel - never a size, and not the first render either.
      // Single-colour and colourless products never enter this branch.
      if (Number(this.dataset.colourValues) > 1) {
        const colour = this.#selected[Number(this.dataset.colourPosition)];
        const previous = this.#syncedColour;
        this.#syncedColour = colour;
        if (previous === undefined || colour === previous) return;
      }

      const gallery = this.#gallery;
      if (!gallery || !variant?.media_id) return;

      const frame = gallery.querySelector(`[data-media-id="${variant.media_id}"]`);

      // Only the mobile carousel scrolls; the desktop column is a static stack
      // and moving it would yank the page out from under the shopper.
      if (!(frame instanceof HTMLElement) || gallery.scrollWidth <= gallery.clientWidth) return;

      gallery.scrollTo({ left: frame.offsetLeft, behavior: 'smooth' });
    }

    #onGalleryScroll = () => {
      const gallery = this.#gallery;
      if (!gallery || gallery.clientWidth === 0) return;

      // Desktop stacks the frames and scrolls vertically; mobile swipes
      // horizontally. Which one is live is a runtime fact, not a breakpoint
      // guess, so read it off the scroller.
      if (gallery.clientHeight > 0 && gallery.scrollHeight > gallery.clientHeight + 1) {
        this.#setThumbIndex(Math.round(gallery.scrollTop / gallery.clientHeight));
        return;
      }

      const frames = this.#frames();
      const step = frames[1] ? frames[1].offsetLeft - frames[0].offsetLeft : gallery.clientWidth;
      this.#setIndex(Math.round(gallery.scrollLeft / step));
    };

    /**
     * The frames on show, in order. A colour gallery
     * (assets/giesto-colour-gallery.js) hides the other colours' frames and
     * numbers the thumbs and dots over what is left, so positions are counted
     * here the same way. Without one this is every frame.
     */
    #frames() {
      return this.#gallery ? Array.from(this.#gallery.children).filter((frame) => !frame.hidden) : [];
    }

    /** Scrolls the media scroller - and nothing else - to one frame. */
    #showFrame(index) {
      const gallery = this.#gallery;
      if (!gallery || !Number.isInteger(index) || index < 0) return;

      const frame = this.#frames()[index];
      if (!(frame instanceof HTMLElement)) return;

      // Measured rather than read off offsetTop/offsetLeft: the frames are
      // position:relative but the scroller is not, so their offsetParent is
      // some ancestor further up and those offsets are not scroller-relative.
      const frameBox = frame.getBoundingClientRect();
      const galleryBox = gallery.getBoundingClientRect();

      if (gallery.scrollHeight > gallery.clientHeight + 1) {
        gallery.scrollTo({
          top: gallery.scrollTop + frameBox.top - galleryBox.top,
          behavior: 'smooth',
        });
      } else if (gallery.scrollWidth > gallery.clientWidth + 1) {
        gallery.scrollTo({
          left: gallery.scrollLeft + frameBox.left - galleryBox.left,
          behavior: 'smooth',
        });
      }

      this.#setThumbIndex(index);
    }

    #setThumbIndex(index) {
      for (const thumb of this.querySelectorAll('[data-gap-thumb]')) {
        const active = Number(thumb.getAttribute('data-gap-thumb')) === index;

        thumb.setAttribute('data-active', String(active));

        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      }
    }

    #setIndex(index) {
      const counter = this.querySelector('[data-gap-counter]');
      if (counter) counter.textContent = String(index + 1);

      for (const dot of this.querySelectorAll('[data-gap-dot]')) {
        const active = Number(dot.getAttribute('data-gap-dot')) === index;
        dot.setAttribute('data-active', String(active));
        dot.setAttribute('aria-current', String(active));
      }
    }

    #scrollToFrame(index) {
      const gallery = this.#gallery;
      if (!gallery || !Number.isInteger(index)) return;

      this.#showFrame(index);
      this.#setIndex(index);
    }
  }

  if (!customElements.get('giesto-store-product')) {
    customElements.define('giesto-store-product', GiestoStoreProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * A second load trigger for <product-recommendations>, against the right root.
   *
   * The theme's element (assets/product-recommendations.js) starts its fetch
   * from an IntersectionObserver with `root: null` and `rootMargin: 0 0 400px 0`.
   * On this theme the desktop scroll container is `.page-wrapper` — base.css
   * gives it `height: 100dvh; overflow-y: auto` at >= 990px — and an observer's
   * rootMargin does NOT expand an intermediate scroll clip. So on desktop the
   * rail gets no pre-load margin at all and only loads once it is genuinely on
   * screen; a layout shift while the PDP's own images settle can make it miss.
   *
   * Measured on the live preview, three runs each: 390px 3/3 loaded, 768px 3/3,
   * 1440px 2/3 — the failure left `performed=false` with the placeholder still
   * showing and no error.
   *
   * This observes the same element against `.page-wrapper` when that is the
   * scroller, and on intersection sets an attribute. Changing any attribute is
   * the element's own reload path (its MutationObserver reloads on attribute
   * changes), so nothing here reaches into the theme's file or duplicates its
   * fetch — and its `recommendationsPerformed` guard makes a double trigger a
   * no-op.
   */
  (() => {
    const SELECTOR = 'product-recommendations.gar';
    const armed = new WeakSet();

    /** The element that actually scrolls, or null for the document. */
    const scrollRoot = () => {
      const wrapper = document.querySelector('.page-wrapper');
      if (!wrapper) return null;

      const overflowY = getComputedStyle(wrapper).overflowY;
      const scrolls = overflowY === 'auto' || overflowY === 'scroll';
      return scrolls && wrapper.scrollHeight > wrapper.clientHeight ? wrapper : null;
    };

    const arm = (element) => {
      if (armed.has(element) || element.dataset.recommendationsPerformed === 'true') return;
      armed.add(element);

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          observer.disconnect();
          if (element.dataset.recommendationsPerformed === 'true') return;
          element.setAttribute('data-gar-visible', '1');
        },
        { root: scrollRoot(), rootMargin: '0px 0px 600px 0px' }
      );

      observer.observe(element);
    };

    const armAll = () => {
      for (const element of document.querySelectorAll(SELECTOR)) arm(element);
    };

    /* Arming before the element upgrades would fire the attribute change at
       nothing — its MutationObserver only starts in connectedCallback. */
    customElements.whenDefined('product-recommendations').then(() => {
      armAll();
      document.addEventListener('shopify:section:load', armAll);
    });
  })();

  /**
   * The rail's prev/next pair.
   *
   * Measured on the reference at 900px, where the row has room to move: one
   * click advances `scrollLeft` by exactly one cell plus the 1px gap (333 -> 334),
   * a second click clamps at the end (435 = scrollWidth - clientWidth) and
   * disables `next`. `prev` starts disabled and both stay in place, faded, at
   * their end — the pair never leaves the row.
   *
   * Everything is delegated rather than bound per element: the fetched branch
   * replaces the whole inner markup when <product-recommendations> resolves,
   * and `shopify:section:load` does not fire for that morph. Clicks delegate
   * off `document`; `scroll` does not bubble but does reach a capture-phase
   * listener there, which is what keeps the disabled state honest.
   */
  (() => {
    const sync = (row) => {
      const nav = row.closest('.gar')?.querySelector('.gar__nav');
      if (!nav) return;

      /* Sub-pixel cell widths make the end land a fraction short of the
         arithmetic maximum, so compare with a pixel of slack. */
      const end = row.scrollWidth - row.clientWidth;
      for (const button of nav.querySelectorAll('.gar__nav-button')) {
        const forward = Number(button.dataset.garStep) > 0;
        button.disabled = forward ? row.scrollLeft >= end - 1 : row.scrollLeft <= 1;
      }
    };

    const syncAll = () => {
      for (const row of document.querySelectorAll('.gar__row')) sync(row);
    };

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element && event.target.closest('.gar__nav-button');
      if (!button) return;

      const row = document.getElementById(button.getAttribute('aria-controls'));
      const cell = row?.querySelector('.gar__cell');
      if (!cell) return;

      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const step = (cell.getBoundingClientRect().width + gap) * Number(button.dataset.garStep);
      row.scrollBy({ left: step, behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const row = event.target instanceof Element ? event.target.closest('.gar__row') : null;
        if (row) sync(row);
      },
      { capture: true, passive: true }
    );

    /* The row arrives after this script on the fetched branch, so watch each
       root for it rather than polling the whole document. Only childList is
       observed: `sync` writes `disabled`, and observing attributes here would
       feed that straight back in. */
    const watched = new WeakSet();
    const initialize = () => {
      for (const root of document.querySelectorAll('.gar')) {
        if (watched.has(root)) continue;
        watched.add(root);
        new MutationObserver(syncAll).observe(root, { childList: true, subtree: true });
      }
      syncAll();
    };

    addEventListener('resize', syncAll, { passive: true });
    document.addEventListener('shopify:section:load', initialize);
    initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-splash"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.GiestoSplashProducts) return;
    window.GiestoSplashProducts = true;

    const focusTargets = new WeakMap();
    const scrollStyles = new WeakMap();

    const restoreDialogState = (dialog, restoreFocus = true) => {
      if (!focusTargets.has(dialog)) return;
      const opener = focusTargets.get(dialog);
      document.body.style.overflowY = scrollStyles.get(dialog) || '';
      scrollStyles.delete(dialog);
      focusTargets.delete(dialog);
      opener.setAttribute('aria-expanded', 'false');
      if (restoreFocus && document.contains(opener)) opener.focus({ preventScroll: true });
    };

    const closeDialog = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
      dialog.close();
      // The native close event is queued. Finish this opening's cleanup now,
      // before another click can reopen the drawer and replace its saved state.
      restoreDialogState(dialog);
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const opener = target.closest('[data-giesto-splash-open]');
      if (opener instanceof HTMLButtonElement) {
        const dialogId = opener.getAttribute('aria-controls');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

        event.preventDefault();
        // Also handle a native close followed by reopening before its event runs.
        restoreDialogState(dialog, false);
        const money = new Intl.NumberFormat(dialog.dataset.locale === 'tr' ? 'tr-TR' : 'en-GB', {
          style: 'currency', currency: dialog.dataset.currency || 'TRY',
        });
        dialog.querySelectorAll('[data-splash-money]').forEach(price => {
          const formatted = money.format(Number(price.dataset.splashMoney) / 100);
          if (price.textContent !== formatted) price.textContent = formatted;
        });
        focusTargets.set(dialog, opener);
        opener.setAttribute('aria-expanded', 'true');
        scrollStyles.set(dialog, document.body.style.overflowY);
        document.body.style.overflowY = 'hidden';
        opener.focus({ preventScroll: true });
        dialog.showModal();
        dialog.querySelector('[data-giesto-splash-close]')?.focus({ preventScroll: true });
        return;
      }

      const closeButton = target.closest('[data-giesto-splash-close]');
      if (closeButton instanceof HTMLButtonElement) {
        closeDialog(closeButton.closest('[data-giesto-splash-dialog]'));
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-giesto-splash-dialog]')) {
        closeDialog(target);
      }
    });

    // Keep the product drawer behind its size picker until adding succeeds.
    document.addEventListener('shopify:cart:lines-update', event => {
      if (event.action !== 'add' || !(event.promise instanceof Promise)) return;
      const source = event.target instanceof Element ? event.target.closest('[data-giesto-splash-dialog]') : null;
      const dialog = source || (document.querySelector('#GiestoStoreSizePicker[data-splash][open]')
        ? document.querySelector('[data-giesto-splash-dialog][open]') : null);
      if (!dialog) return;
      event.promise.then(result => {
        if (!result?.detail?.didError) closeDialog(dialog);
      }).catch(() => {});
    });

    document.addEventListener('cancel', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      event.preventDefault();
      closeDialog(dialog);
    }, true);

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      // Ignore an old close event delivered after the same drawer reopened.
      if (!dialog.open) restoreDialogState(dialog);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-video-hero')) {
    class GiestoVideoHero extends HTMLElement {
      connectedCallback() {
        this.teardown();

        this.breakpoint = window.matchMedia('(max-width: 768px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        this.parallaxStates = [];
        this.onBreakpointChange = this.handleBreakpointChange.bind(this);
        this.onScroll = this.handleScroll.bind(this);
        this.onReducedMotionChange = this.handleReducedMotionChange.bind(this);
        this.onMediaLoad = this.handleMediaLoad.bind(this);
        this.onSectionLoad = this.handleSectionLoad.bind(this);
        this.onSectionUnload = this.handleSectionUnload.bind(this);

        this.addMediaListener(this.breakpoint, this.onBreakpointChange);
        this.addMediaListener(this.reduceMotion, this.onReducedMotionChange);

        document.addEventListener('shopify:section:load', this.onSectionLoad, { signal: this.controller.signal });
        document.addEventListener('shopify:section:unload', this.onSectionUnload, { signal: this.controller.signal });

        this.loadActiveVideo();
        this.setupParallax();
      }

      teardown() {
        if (this.parallaxFrame) {
          window.cancelAnimationFrame(this.parallaxFrame);
        }

        this.parallaxFrame = null;

        if (this.breakpoint && this.onBreakpointChange) {
          this.removeMediaListener(this.breakpoint, this.onBreakpointChange);
        }

        if (this.reduceMotion && this.onReducedMotionChange) {
          this.removeMediaListener(this.reduceMotion, this.onReducedMotionChange);
        }

        if (this.controller) {
          this.controller.abort();
        }

        this.parallaxStates?.forEach((state) => {
          state.overlay.style.removeProperty('--giesto-overlay-translate-y');
          state.overlay.classList.remove('is-visible');
          delete state.overlay.dataset.giestoParallaxManaged;
        });

        this.parallaxStates = [];
        this.controller = null;
      }

      disconnectedCallback() {
        this.teardown();
      }

      handleBreakpointChange() {
        this.loadActiveVideo();
        this.refreshParallax(this.reduceMotion?.matches);
      }

      handleScroll() {
        this.refreshParallax(this.reduceMotion?.matches);
      }

      handleMediaLoad() {
        this.refreshParallax(this.reduceMotion?.matches);
      }

      handleSectionLoad(event) {
        if (this.ownsSectionEvent(event) && this.isConnected) {
          this.connectedCallback();
        }
      }

      handleSectionUnload(event) {
        if (this.ownsSectionEvent(event)) {
          this.teardown();
        }
      }

      ownsSectionEvent(event) {
        const target = event.target;
        return target === this || Boolean(target?.contains?.(this));
      }

      setupParallax() {
        if (this.dataset.enableParallax !== 'true') return;

        this.parallaxStates = Array.from(this.querySelectorAll('[data-giesto-parallax]'))
          .map((overlay) => ({
            overlay,
            section: overlay.closest('[data-giesto-media-wrapper]'),
            currentY: 0,
            targetY: 0,
          }))
          .filter((state) => state.section);

        if (!this.parallaxStates.length) return;

        this.parallaxStates.forEach((state) => {
          state.overlay.dataset.giestoParallaxManaged = 'true';
          state.overlay.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', this.onMediaLoad, { signal: this.controller.signal });
            if (image.complete) this.handleMediaLoad();
          });
        });

        this.querySelectorAll('.giesto-video-hero__media').forEach((media) => {
          media.addEventListener('load', this.onMediaLoad, { signal: this.controller.signal });
          media.addEventListener('loadedmetadata', this.onMediaLoad, { signal: this.controller.signal });
        });

        document.addEventListener('scroll', this.onScroll, {
          capture: true,
          passive: true,
          signal: this.controller.signal,
        });
        window.addEventListener('resize', this.onScroll, {
          passive: true,
          signal: this.controller.signal,
        });

        this.refreshParallax(this.reduceMotion.matches);
      }

      handleReducedMotionChange(event) {
        this.refreshParallax(event.matches);
      }

      addMediaListener(query, listener) {
        if (query.addEventListener) {
          query.addEventListener('change', listener);
        } else {
          query.addListener(listener);
        }
      }

      removeMediaListener(query, listener) {
        if (query.removeEventListener) {
          query.removeEventListener('change', listener);
        } else {
          query.removeListener(listener);
        }
      }

      loadActiveVideo() {
        const activeDevice = this.breakpoint.matches ? 'mobile' : 'desktop';

        this.querySelectorAll('[data-giesto-video]').forEach((video) => {
          const isActive = video.dataset.giestoDevice === activeDevice;

          if (isActive) {
            if (video.dataset.giestoLoaded === 'true') return;

            const poster = video.dataset.giestoPoster;
            if (poster) video.poster = poster;

            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
            });

            video.dataset.giestoLoaded = 'true';
            video.load();

            const playAttempt = video.play();
            if (playAttempt) playAttempt.catch(() => {});
          } else if (video.dataset.giestoLoaded === 'true') {
            video.pause();
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.removeAttribute('poster');
            video.dataset.giestoLoaded = 'false';
            video.load();
          }
        });
      }

      refreshParallax(immediate = false) {
        if (!this.parallaxStates?.length) return;

        const shouldApplyImmediately = Boolean(immediate || this.reduceMotion?.matches);

        if (shouldApplyImmediately) {
          if (this.parallaxFrame) {
            window.cancelAnimationFrame(this.parallaxFrame);
            this.parallaxFrame = null;
          }

          this.applyParallax(true);
          return;
        }

        if (this.parallaxFrame) return;

        this.parallaxFrame = window.requestAnimationFrame(() => {
          this.parallaxFrame = null;
          this.applyParallax(false);
        });
      }

      applyParallax(immediate) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        let shouldContinue = false;

        this.parallaxStates.forEach((state) => {
          const section = state.section;
          const overlay = state.overlay;
          const sectionRect = section.getBoundingClientRect();
          const isRendered = section.getClientRects().length > 0 && sectionRect.height > 0;
          const isWithinBuffer = sectionRect.bottom >= -120 && sectionRect.top <= viewportHeight + 120;
          const logoHeight = overlay.getBoundingClientRect().height;

          if (!isRendered || !isWithinBuffer || !logoHeight) {
            state.currentY = 0;
            state.targetY = 0;
            overlay.style.setProperty('--giesto-overlay-translate-y', '0px');
            overlay.classList.remove('is-visible');
            return;
          }

          const progress = Math.max(
            0,
            Math.min(1, (viewportHeight - sectionRect.top + 120) / (viewportHeight + sectionRect.height + 240))
          );
          const easedProgress = progress * progress * (3 - 2 * progress);
          state.targetY = Math.max(sectionRect.height - logoHeight, 0) * easedProgress;
          overlay.classList.add('is-visible');

          if (immediate) {
            state.currentY = state.targetY;
          } else {
            state.currentY += (state.targetY - state.currentY) * 0.16;
            if (Math.abs(state.targetY - state.currentY) > 0.1) {
              shouldContinue = true;
            } else {
              state.currentY = state.targetY;
            }
          }

          overlay.style.setProperty('--giesto-overlay-translate-y', `${state.currentY.toFixed(2)}px`);
        });

        if (!immediate && shouldContinue) {
          this.refreshParallax(false);
        }
      }
    }

    customElements.define('giesto-video-hero', GiestoVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-wishlist"] && !Shopify.designMode) return;
  try {
    
  class GiestoWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid=this.querySelector('[data-gwl-grid]');this.template=this.querySelector('[data-gwl-template]');
      this.previewGrid=this.querySelector('[data-gwl-preview-grid]');this.cards=[];
      this.empty=this.querySelector('[data-gwl-empty]');this.lead=this.querySelector('[data-gwl-lead]');
      this.counter=this.querySelector('[data-gwl-count]');this.view=this.querySelector('[data-gwl-view]');this.toolbar=this.querySelector('[data-gwl-toolbar]');
      this.loginShort=this.querySelector('[data-gwl-login-short]');this.removeLabel=this.dataset.removeLabel||'Remove';
      this.addLabel=this.dataset.addLabel||'Choose size';this.productCache=new Map();this.colourCache=new Map();this.render=this.render.bind(this);
      this.addEventListener('click',this.onClick);document.addEventListener('giesto:wishlist:change',this.render);
      if(window.GiestoWishlist)this.render();else window.addEventListener('DOMContentLoaded',this.render,{once:true});
    }
    disconnectedCallback(){document.removeEventListener('giesto:wishlist:change',this.render)}
    onClick=async(event)=>{
      const target=event.target instanceof Element?event.target:null;const viewButton=target?.closest('[data-gwl-columns]');
      if(viewButton){const columns=viewButton.dataset.gwlColumns;this.arrangeCards(columns);for(const button of this.querySelectorAll('[data-gwl-columns]'))button.setAttribute('aria-pressed',String(button===viewButton));try{localStorage.setItem('giesto:wishlist-columns',columns)}catch{}return}
      const galleryButton=target?.closest('[data-gwl-gallery]');
      if(galleryButton){event.preventDefault();event.stopPropagation();const track=galleryButton.closest('.gwl__media-shell')?.querySelector('[data-gwl-track]');if(track){track.scrollBy({left:Number(galleryButton.dataset.gwlGallery)*track.clientWidth,behavior:'smooth'})}return}
      const remove=target?.closest('[data-gwl-remove]');if(remove){const id=remove.closest('[data-id]')?.dataset.id;if(id)window.GiestoWishlist?.remove(id);return}
      const add=target?.closest('[data-gwl-add]');if(!(add instanceof HTMLButtonElement))return;event.preventDefault();event.stopPropagation();await this.openSizePicker(add);
    }
    async getProduct(item){
      if(this.productCache.has(item.id))return this.productCache.get(item.id);
      const path=new URL(item.url||`/products/${item.handle}`,location.origin).pathname.replace(/\/$/,'');
      const promise=(async()=>{
        let response=await fetch(`${path}.js`,{headers:{Accept:'application/json'}});
        // Shopify's local development proxy can lose its product-JSON session.
        // Only public catalog data is read from the store; no cookies are sent.
        if([401,403].includes(response.status)&&['localhost','127.0.0.1'].includes(location.hostname)&&this.dataset.catalogOrigin){
          response=await fetch(new URL(`${path}.js`,this.dataset.catalogOrigin),{credentials:'omit',headers:{Accept:'application/json'}});
        }
        return response.ok?response.json():null;
      })().catch(()=>null);
      this.productCache.set(item.id,promise);return promise;
    }
    getColourGroup(item){
      if(this.colourCache.has(item.id))return this.colourCache.get(item.id);
      const query=new URLSearchParams({shop:this.dataset.shop||'',product_id:String(item.id)});
      const promise=fetch(`/apps/renk-grubu/get-group?${query}`,{headers:{Accept:'application/json'}})
        .then(response=>response.ok?response.json():null).catch(()=>null);
      this.colourCache.set(item.id,promise);return promise;
    }
    showColour(cell,item,colour,background,extra){
      const row=cell.querySelector('[data-gwl-colour]');if(!row)return;
      row.href=item.url;row.title=colour;row.setAttribute('aria-label',`${item.title}: ${colour}${extra>0?` +${extra}`:''}`);
      row.querySelector('[data-gwl-swatch]').style.background=background;
      row.querySelector('[data-gwl-colour-count]').textContent=extra>0?`+${extra}`:'';row.hidden=false;
    }
    enrichColours(cell,item){
      if(cell.dataset.gwlColours)return;cell.dataset.gwlColours='pending';
      // The product JSON is the same cached request enrichCard makes; it tells
      // whether the item holds several colours itself, which rules out an app group.
      Promise.all([this.getColourGroup(item),this.getProduct(item)]).then(([source,product])=>{
        if(!cell.isConnected){delete cell.dataset.gwlColours;return}
        if(!source?.success||!window.GiestoColorGroups)return;
        const colourNames=['color','colour','farbe','couleur','kleur','renk'];const colourOption=(Array.isArray(product?.options)?product.options:[]).find(option=>colourNames.includes(String(option?.name||'').toLowerCase()));
        const multiColour=Array.isArray(colourOption?.values)&&colourOption.values.length>1;
        const group=window.GiestoColorGroups.match({dataset:{p:String(item.id),locale:this.dataset.locale,multiColour:String(multiColour)}},source);
        const current=group.products.find(product=>String(product.id).replace('gid://shopify/Product/','')===String(item.id));
        if(!current?.colorCode)return;
        cell.dataset.gwlLinkedColour='true';cell.dataset.gwlColours='true';
        this.showColour(cell,item,current.color||'',current.colorCode,group.products.length-1);
      });
    }
    async openSizePicker(button){
      const cell=button.closest('[data-id]');const item=window.GiestoWishlist?.items.find(entry=>String(entry.id)===cell?.dataset.id);if(!item)return;
      button.disabled=true;const product=await this.getProduct(item);button.disabled=false;if(!product){location.href=item.url;return}
      const options=Array.isArray(product.options)?product.options:[];const colourNames=['color','colour','farbe','couleur','kleur','renk'];
      let sizePosition=options.findIndex(option=>!colourNames.includes(String(option?.name||option).toLowerCase()));if(sizePosition<0)sizePosition=0;
      let variants=cell.querySelector('[data-gac-variants]');if(!variants){variants=document.createElement('script');variants.type='application/json';variants.dataset.gacVariants='';cell.append(variants)}
      variants.textContent=JSON.stringify(product.variants||[]);button.dataset.productId=String(product.id||item.id);button.dataset.productUrl=item.url;
      button.dataset.productTitle=item.title;button.dataset.sizePosition=String(sizePosition);
      document.dispatchEvent(new CustomEvent('giesto:size-picker:open',{detail:{trigger:button,returnFocus:button}}));
    }
    enrichCard(cell,item){
      if(cell.dataset.gwlEnriched)return;cell.dataset.gwlEnriched='pending';
      this.getProduct(item).then(product=>{
        if(!product||!cell.isConnected){delete cell.dataset.gwlEnriched;return}cell.dataset.gwlEnriched='true';
        const track=cell.querySelector('[data-gwl-track]');const productMedia=Array.isArray(product.media)?product.media.filter(media=>media?.media_type==='image'):[];
        const images=productMedia.length?productMedia.map(media=>media.src||media.preview_image?.src):Array.isArray(product.images)?product.images:[];
        if(track&&images.length){const fragment=document.createDocumentFragment();images.forEach((source,index)=>{const slide=document.createElement('span');slide.className='gwl__slide';const image=document.createElement('img');image.className='gwl__image';image.src=String(source).startsWith('//')?`https:${source}`:source;image.alt=item.title;image.loading=index?'lazy':'eager';image.width=600;image.height=800;slide.append(image);fragment.append(slide)});track.replaceChildren(fragment);
          const previous=cell.querySelector('[data-gwl-gallery="-1"]');const next=cell.querySelector('[data-gwl-gallery="1"]');const update=()=>{const index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));if(previous)previous.disabled=index<=0;if(next)next.disabled=index>=images.length-1};let frame=0;track.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;update()})},{passive:true});if(previous)previous.hidden=images.length<2;if(next)next.hidden=images.length<2;update();
        }
        const names=['color','colour','farbe','couleur','kleur','renk'];const options=Array.isArray(product.options)?product.options:[];
        const colourOption=options.find(option=>names.includes(String(option?.name||'').toLowerCase()));const values=Array.isArray(colourOption?.values)?colourOption.values:[];
        if(!values.length||cell.dataset.gwlLinkedColour)return;
        const colour=String(values[0]||'').normalize('NFKD').replace(/\p{M}/gu,'').toLowerCase().replace(/ı/g,'i');
        const colours={black:'#202020',siyah:'#202020',white:'#f7f7f7',beyaz:'#f7f7f7',navy:'#173052',lacivert:'#173052',blue:'#477da8',mavi:'#477da8',brown:'#765039',kahverengi:'#765039',beige:'#d9c49c',bej:'#d9c49c',grey:'#9a9a9a',gray:'#9a9a9a',gri:'#9a9a9a',green:'#477b59',yeşil:'#477b59',red:'#bd3030',kırmızı:'#bd3030'};
        this.showColour(cell,item,String(values[0]),Object.entries(colours).find(([key])=>colour.includes(key))?.[1]||'#d8d8d8',values.length-1);
      });
    }
    arrangeCards(columns){
      this.grid.dataset.columns=columns;
      if(this.previewGrid){
      this.previewGrid.dataset.columns=columns;
      // ARKET's guest list exposes the first group and previews the next group
      // underneath an inert sign-in panel. The saved store retains every item.
      const limit=columns==='wide'?3:4;
      this.grid.replaceChildren(...this.cards.slice(0,limit));
      this.previewGrid.replaceChildren(...this.cards.slice(limit,limit*2));
      }
      for(const cell of this.cards){if(!cell.isConnected)continue;const item=window.GiestoWishlist?.items.find(item=>String(item.id)===cell.dataset.id);if(item){this.enrichCard(cell,item);this.enrichColours(cell,item)}}
    }
    render(){
      const store=window.GiestoWishlist;if(!store||!this.grid||!this.template)return;store.refresh?.();const items=store.items;this.grid.replaceChildren();
      this.cards=[];
      for(const item of items){const node=this.template.content.cloneNode(true);const cell=node.querySelector('.gwl__cell');const link=node.querySelector('[data-gwl-link]');
        const image=node.querySelector('[data-gwl-image]');const name=node.querySelector('[data-gwl-name]');const price=node.querySelector('[data-gwl-price]');
        const removes=node.querySelectorAll('[data-gwl-remove]');const addLabels=node.querySelectorAll('[data-gwl-add-label]');
        if(cell)cell.dataset.id=String(item.id);if(link)link.href=item.url;if(image){image.src=item.image;image.alt=item.title;if(!item.image)image.remove()}
        if(name){name.textContent=item.title;name.href=item.url}if(price)price.textContent=item.price;for(const remove of removes)remove.setAttribute('aria-label',`${this.removeLabel} ${item.title}`);
        for(const addLabel of addLabels)addLabel.textContent=`${this.addLabel}: ${item.title}`;this.grid.append(node);if(cell)this.cards.push(cell);
      }
      const hasItems=items.length>0;const becameEmpty=this.hadItems===true&&!hasItems;this.hadItems=hasItems;this.toggleAttribute('data-empty',!hasItems);
      this.empty.hidden=hasItems;this.lead.hidden=!hasItems;if(this.loginShort)this.loginShort.hidden=!hasItems;
      this.toolbar.hidden=!hasItems;this.grid.hidden=!hasItems;const unit=items.length===1?this.dataset.unitOne:this.dataset.unitOther;this.counter.textContent=`${items.length} ${unit}`;
      let columns='dense';try{if(localStorage.getItem('giesto:wishlist-columns')==='wide')columns='wide'}catch{}this.arrangeCards(columns);
      for(const button of this.querySelectorAll('[data-gwl-columns]'))button.setAttribute('aria-pressed',String(button.dataset.gwlColumns===columns));
      if(becameEmpty)requestAnimationFrame(()=>{if(document.scrollingElement)document.scrollingElement.scrollTop=0;scrollTo({top:0,behavior:'auto'})});
    }
  }
  if(!customElements.get('giesto-wishlist-page'))customElements.define('giesto-wishlist-page',GiestoWishlistPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('giesto-main-collection')) {
    class GiestoMainCollection extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('theme-drawer#filters-drawer');
        this.sort = this.querySelector('[data-giesto-collection-sort]');
        this.tagSubcategoryLinks = this.querySelectorAll('[data-giesto-collection-tag]');
        this.#onDrawerOpen = this.#onDrawerOpen.bind(this);
        this.#onDrawerClose = this.#onDrawerClose.bind(this);
        this.#onSortChange = this.#onSortChange.bind(this);
        this.#onTagSubcategoryClick = this.#onTagSubcategoryClick.bind(this);

        this.drawer?.addEventListener('theme-drawer:open', this.#onDrawerOpen);
        this.drawer?.addEventListener('theme-drawer:close', this.#onDrawerClose);
        this.sort?.addEventListener('change', this.#onSortChange);
        this.tagSubcategoryLinks.forEach((link) => {
          link.addEventListener('click', this.#onTagSubcategoryClick);
        });

        if (this.drawer?.hasAttribute('open')) this.#onDrawerOpen();
      }

      disconnectedCallback() {
        this.drawer?.removeEventListener('theme-drawer:open', this.#onDrawerOpen);
        this.drawer?.removeEventListener('theme-drawer:close', this.#onDrawerClose);
        this.sort?.removeEventListener('change', this.#onSortChange);
        this.tagSubcategoryLinks?.forEach((link) => {
          link.removeEventListener('click', this.#onTagSubcategoryClick);
        });

        if (document.documentElement.dataset.giestoCollectionFilter === this.dataset.sectionId) {
          delete document.documentElement.dataset.giestoCollectionFilter;
        }
      }

      #onDrawerOpen() {
        this.dataset.filterOpen = 'true';
        document.documentElement.dataset.giestoCollectionFilter = this.dataset.sectionId;
      }

      #onDrawerClose() {
        delete this.dataset.filterOpen;

        if (document.documentElement.dataset.giestoCollectionFilter === this.dataset.sectionId) {
          delete document.documentElement.dataset.giestoCollectionFilter;
        }
      }

      #onSortChange(event) {
        const sortBy = event.currentTarget.value;
        const nextUrl = new URL(window.location.href);

        if (sortBy) {
          nextUrl.searchParams.set('sort_by', sortBy);
        } else {
          nextUrl.searchParams.delete('sort_by');
        }

        nextUrl.searchParams.delete('page');
        window.location.assign(nextUrl.toString());
      }

      #onTagSubcategoryClick(event) {
        const link = event.currentTarget;
        const parameter = this.dataset.giestoTagFilterParam;

        if (!(link instanceof HTMLAnchorElement) || !parameter) return;

        event.preventDefault();

        const nextUrl = new URL(window.location.href);
        const value = link.dataset.giestoCollectionTag;

        nextUrl.searchParams.delete(parameter);
        if (value) nextUrl.searchParams.set(parameter, value);
        nextUrl.searchParams.delete('page');

        window.location.assign(nextUrl.toString());
      }
    }

    customElements.define('giesto-main-collection', GiestoMainCollection);
  }

  if (!customElements.get('giesto-collection-card')) {
    class GiestoCollectionCard extends HTMLElement {
      #controller;
      #opener;

      connectedCallback() {
        if (this.#controller) return;

        this.#controller = new AbortController();
        const { signal } = this.#controller;

        this.addEventListener('click', this.#handleClick, { signal });
        this.ownerDocument.addEventListener('keydown', this.#handleKeydown, { signal });
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = undefined;
        this.#opener = undefined;
      }

      #handleClick = (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-giesto-quick-add-trigger]');
        if (trigger && this.contains(trigger)) {
          event.preventDefault();
          this.#open(trigger);
          return;
        }

        const closeButton = event.target.closest('[data-giesto-quick-add-close]');
        if (closeButton && this.contains(closeButton)) {
          event.preventDefault();
          this.#close();
          return;
        }

        const variantButton = event.target.closest('[data-giesto-quick-add-variant]');
        if (!(variantButton instanceof HTMLButtonElement) || !this.contains(variantButton) || variantButton.disabled) return;

        const variantId = variantButton.dataset.giestoVariantId;
        const form = this.querySelector('[data-giesto-quick-add-form]');
        const variantInput = form?.querySelector('input[name="id"]');
        if (!(form instanceof HTMLFormElement) || !(variantInput instanceof HTMLInputElement) || !variantId) return;

        variantInput.disabled = false;
        variantInput.value = variantId;
        this.#close(false);
        form.requestSubmit();
      };

      #handleKeydown = (event) => {
        if (event.key !== 'Escape' || this.dataset.giestoQuickAddOpen !== 'true') return;

        event.preventDefault();
        this.#close();
      };

      #open = (trigger) => {
        const overlay = this.querySelector('[data-giesto-quick-add-overlay]');
        if (!(overlay instanceof HTMLElement)) return;

        this.ownerDocument
          .querySelectorAll('giesto-collection-card[data-giesto-quick-add-open="true"]')
          .forEach((openCard) => {
            if (openCard !== this && openCard instanceof GiestoCollectionCard) openCard.#close(false);
          });

        this.#opener = trigger;
        this.dataset.giestoQuickAddOpen = 'true';
        trigger.setAttribute('aria-expanded', 'true');
        overlay.inert = false;
        overlay.setAttribute('aria-hidden', 'false');

        const focusTarget = overlay.querySelector(
          '[data-giesto-quick-add-variant]:not([disabled]), [data-giesto-quick-add-close]'
        );
        requestAnimationFrame(() => focusTarget instanceof HTMLElement && focusTarget.focus({ preventScroll: true }));
      };

      #close = (restoreFocus = true) => {
        const overlay = this.querySelector('[data-giesto-quick-add-overlay]');
        if (!(overlay instanceof HTMLElement)) return;

        this.dataset.giestoQuickAddOpen = 'false';
        overlay.inert = true;
        overlay.setAttribute('aria-hidden', 'true');

        const trigger = this.querySelector('[data-giesto-quick-add-trigger]');
        if (trigger instanceof HTMLElement) trigger.setAttribute('aria-expanded', 'false');

        if (restoreFocus && this.#opener instanceof HTMLElement) {
          this.#opener.focus({ preventScroll: true });
        }
        this.#opener = undefined;
      };
    }

    customElements.define('giesto-collection-card', GiestoCollectionCard);
  }

  } catch(e) { console.error(e); }
})();
})();
